export const GLOSSARY = [
    {
       "key":1,
       "value":"AAA/Aaa",
       "description":"The highest investmentgrade rating for bond issuers awarded by Standard & Poor’s and Moody’s ratings agencies."
    },
    {
       "key":2,
       "value":"acceptance waiver and consent (AWAC)",
       "description":"A process used when a respondent does not contest an allegation made by FINRA. The respondent accepts the findings without admitting any wrongdoing and agrees to accept any penalty for the violation."
    },
    {
       "key":3,
       "value":"account executive (AE)",
       "description":"An individual who is duly licensed to represent a broker dealer in securities transactions or investment banking business. Also known as a registered representative."
    },
    {
       "key":4,
       "value":"accredited investor",
       "description":"Any individual or institution that meets one or more of the following: (1) a net worth exceeding $1 million, excluding the primary residence, or (2) is single and has an annual income of $200,000 or more or $300,000 jointly with a spouse."
    },
    {
       "key":5,
       "value":"accretion",
       "description":"An accounting method used to step up an investor’s cost base for a bond purchased at a discount."
    },
    {
       "key":6,
       "value":"accrued interest",
       "description":"The portion of a debt securities future interest payment that has been earned by the seller of the security. The purchaser must pay this amount of accrued interest to the seller at the time of the transaction’s settlement. Interest accrues from the date of the last interest payment date up to, but not including, the transaction’s settlement date."
    },
    {
       "key":7,
       "value":"accumulation stage",
       "description":"The period during which an annuitant is making contributions to an annuity contract."
    },
    {
       "key":8,
       "value":"accumulation unit",
       "description":"A measure used to determine the annuitant’s proportional ownership interest in the insurance company’s separate account during the accumulation stage. During the accumulation stage, the number of accumulation units owned by the annuitant changes and their value varies."
    },
    {
       "key":9,
       "value":"acid-test ratio",
       "description":"A measure of corporate liquidity found by subtracting inventory from current assets and dividing the result by the current liabilities."
    },
    {
       "key":10,
       "value":"ACT",
       "description":"See Automated Comparison Transaction (ACT) service."
    },
    {
       "key":11,
       "value":"ad valorem tax",
       "description":"A tax based on the value of the subject property."
    },
    {
       "key":12,
       "value":"adjusted basis",
       "description":"The value assigned to an asset after all deductions or additions for improvements have been taken into consideration."
    },
    {
       "key":13,
       "value":"adjusted gross income (AGI)",
       "description":"An accounting measure employed by the IRS to help determine tax liability. AGI = earned income + investment income (portfolio income) + capital gains + net passive income."
    },
    {
       "key":14,
       "value":"administrator",
       "description":"(1) An individual authorized to oversee the liquidation of an intestate decedent’s estate. (2) An individual or agency that administers securities’ laws within a state."
    },
    {
       "key":15,
       "value":"ADR/ADS",
       "description":"See American depositary receipt (ADR)."
    },
    {
       "key":16,
       "value":"advance/decline line",
       "description":"Measures the health of the overall market by calculating advancing issues and subtracting the number of declining issues."
    },
    {
       "key":17,
       "value":"advance refunding",
       "description":"The early refinancing of municipal securities. A new issue of bonds is sold to retire the old issue at its first available call date or maturity."
    },
    {
       "key":18,
       "value":"advertisement",
       "description":"Any material that is distributed by a broker dealer or issuer for the purpose of increasing business or public awareness for the firm or issuer. The broker dealer or issuer must distribute advertisements to an audience that is not controlled. Advertisements are distributed through any of the following: newspapers/ magazines, radio, TV, billboards, telephone."
    },
    {
       "key":19,
       "value":"affiliate",
       "description":"An individual who owns 10% or more of the company’s voting stock. In the case of a direct participation program (DPP), this is anyone who controls the partnership or is controlled by the partnership."
    },
    {
       "key":20,
       "value":"agency issue",
       "description":"A debt security issued by any authorized entity of the U.S. government. The debt security is an obligation of the issuing entity, not an obligation of the U.S. government (with the exception of Ginnie Mae and the Federal Import Export Bank issues)."
    },
    {
       "key":21,
       "value":"agency transaction",
       "description":"A transaction made by a firm for the benefit of a customer. The firm merely executes a customer’s order and charges a fee for the service, which is known as a commission."
    },
    {
       "key":22,
       "value":"agent",
       "description":"A firm or an individual who executes securities transactions for customers and charges a service fee known as a commission. Also known as a broker."
    },
    {
       "key":23,
       "value":"aggregate indebtedness",
       "description":"The total amount of the firm’s customer-related debts."
    },
    {
       "key":24,
       "value":"allied member",
       "description":"An owner-director or 5% owner of an NYSE member firm. Allied members may not trade on the floor."
    },
    {
       "key":25,
       "value":"all-or-none (AON) order",
       "description":"A non-time-sensitive order that stipulates that the customer wants to buy or sell all of the securities in the order."
    },
    {
       "key":26,
       "value":"all-or-none underwriting",
       "description":"A type of underwriting that states that the issuer wants to sell all of the securities being offered or none of the securities being offered. The proceeds from the issue will be held in escrow until all securities are sold."
    },
    {
       "key":27,
       "value":"alpha",
       "description":"A measure of the projected change in the security’s price as a result of fundamental factors relating only to that company."
    },
    {
       "key":28,
       "value":"alternative minimum tax (AMT)",
       "description":"A method used to calculate the tax liability for some high-income earners that adds back the deductions taken for certain tax preference items."
    },
    {
       "key":29,
       "value":"AMBAC Indemnity Corporation",
       "description":"Insures the interest and principal payments for municipal bonds."
    },
    {
       "key":30,
       "value":"American depositary receipt (ADR)/American depositary security (ADS)",
       "description":"A receipt representing the beneficial ownership of foreign securities being held in trust overseas by a foreign branch of a U.S. bank. ADRs/ADSs facilitate the trading and ownership of foreign securities and trade in the United States on an exchange or in the over-the-counter markets."
    },
    {
       "key":31,
       "value":"American Stock Exchange (AMEX)",
       "description":"An exchange located in New York using the dual-auction method and specialist system to facilitate trading in stocks, options, exchange-traded funds, and portfolios. AMEX was acquired by the NYSE Euronext and is now part of NYSE Alternext."
    },
    {
       "key":32,
       "value":"amortization",
       "description":"An accounting method that reduces the value of an asset over its projected useful life. Also the way that loan principal is systematically paid off over the life of a loan."
    },
    {
       "key":33,
       "value":"annual compliance review",
       "description":"All firms must hold at least one compliance meeting per year with all of its agents."
    },
    {
       "key":34,
       "value":"annuitant",
       "description":"An individual who receives scheduled payments from an annuity contract."
    },
    {
       "key":35,
       "value":"annuitize",
       "description":"A process by which an individual converts from the accumulation stage to the payout stage of an annuity contract. This is accomplished by exchanging accumulation units for annuity units. Once a payout option is selected, it cannot be changed."
    },
    {
       "key":36,
       "value":"annuity",
       "description":"A contract between an individual and an insurance company that is designed to provide the annuitant with lifetime income in exchange for either a lump sum or periodic deposits into the contract."
    },
    {
       "key":37,
       "value":"annuity unit",
       "description":"An accounting measure used to determine an individual’s proportionate ownership of the separate account during the payout stage of the contract. The number of annuity units owned by an individual remains constant, and their value, which may vary, is used to determine the amount of the individual’s annuity payment."
    },
    {
       "key":38,
       "value":"appreciation",
       "description":"An asset’s increase in value over time."
    },
    {
       "key":39,
       "value":"arbitrage",
       "description":"An investment strategy used to profit from market inefficiencies."
    },
    {
       "key":40,
       "value":"arbitration",
       "description":"A forum provided by both the NYSE and FINRA to resolve disputes between two parties. Only a public customer may not be forced to settle a dispute through arbitration. The public customer must agree to arbitration in writing. All industry participants must settle disputes through arbitration."
    },
    {
       "key":41,
       "value":"ask",
       "description":"See offer."
    },
    {
       "key":42,
       "value":"assessed value",
       "description":"A base value assigned to property for the purpose of determining tax liability."
    },
    {
       "key":43,
       "value":"assessment",
       "description":"An additional amount of taxes due as a result of a municipal project that the homeowner benefits from. Also an additional call for capital by a direct participation program."
    },
    {
       "key":44,
       "value":"asset",
       "description":"Anything of value owned by an individual or a corporation."
    },
    {
       "key":45,
       "value":"asset allocation fund",
       "description":"A mutual fund that spreads its investments among different asset classes (i.e., stocks, bonds, and other investments) based on a predetermined formula."
    },
    {
       "key":46,
       "value":"assignee",
       "description":"A person to whom the ownership of an asset is being transferred."
    },
    {
       "key":47,
       "value":"assignment",
       "description":"(1) The transfer of ownership or rights through a signature. (2) The notification given to investors who are short an option that the option holder has exercised its right and they must now meet their obligations as detailed in the option contract."
    },
    {
       "key":48,
       "value":"associated person",
       "description":"Any individual under the control of a broker dealer, issuer, or bank, including employees, officers, and directors, as well as those individuals who control or have common control of a broker dealer, issuer, or bank."
    },
    {
       "key":49,
       "value":"assumed interest rate (AIR)",
       "description":"(1) A benchmark used to determine the minimum rate of return that must be realized by a variable annuity’s separate account during the payout phase in order to keep the annuitant’s payments consistent. (2) In the case of a variable life insurance policy, the minimum rate of return that must be achieved in order to maintain the policy’s variable death benefit."
    },
    {
       "key":50,
       "value":"at-the-close order",
       "description":"An order that stipulates that the security is to be bought or sold only at the close of the market, or as close to the close as is reasonable, or not at all."
    },
    {
       "key":51,
       "value":"at the money",
       "description":"A term used to describe an option when the underlying security price is equal to the exercise price of the option."
    },
    {
       "key":52,
       "value":"at-the-opening order",
       "description":"An order that stipulates that the security is to be bought or sold only at the opening of the market, or as close to the opening as is reasonable, or not at all."
    },
    {
       "key":53,
       "value":"auction market",
       "description":"The method of trading employed by stock exchanges that allows buyers and sellers to compete with one another in a centralized location."
    },
    {
       "key":54,
       "value":"authorized stock",
       "description":"The maximum number of shares that a corporation can sell in an effort to raise capital. The number of authorized shares may only be changed by a vote of the shareholders."
    },
    {
       "key":55,
       "value":"Automated Comparison Transaction (ACT) service",
       "description":"ACT is the service that clears and locks Nasdaq trades."
    },
    {
       "key":56,
       "value":"average cost",
       "description":"A method used to determine the cost of an investment for an investor who has made multiple purchases of the same security at different times and prices. An investor’s average cost may be used to determine a cost base for tax purposes or to evaluate the profitability of an investment program, such as dollar-cost averaging. Average cost is determined by dividing the total dollars invested by the number of shares purchased."
    },
    {
       "key":57,
       "value":"average price",
       "description":"A method used to determine the average price paid by an investor for a security that has been purchased at different times and prices, such as through dollar-cost averaging. An investor’s average price is determined by dividing the total of the purchase prices by the number of purchases."
    },
    {
       "key":58,
       "value":"BBB/Baa",
       "description":"The lowest ratings assigned by Standard & Poor’s and Moody’s for debt in the investmentgrade category."
    },
    {
       "key":59,
       "value":"back-end load",
       "description":"A mutual fund sales charge that is assessed upon the redemption of the shares. The amount of the sales charge to be assessed upon redemption decreases the longer the shares are held. Also known as a contingent deferred sales charge."
    },
    {
       "key":60,
       "value":"backing away",
       "description":"The failure of an over-the-counter market maker to honor firm quotes. It is a violation of FINRA rules."
    },
    {
       "key":61,
       "value":"balanced fund",
       "description":"A mutual fund whose investment policy requires that the portfolio’s holdings are diversified among asset classes and invested in common and preferred stock, bonds, and other debt instruments. The exact asset distribution among the asset classes will be predetermined by a set formula that is designed to balance out the investment return of the fund."
    },
    {
       "key":62,
       "value":"balance of payments",
       "description":"The net balance of all international transactions for a country in a given time."
    },
    {
       "key":63,
       "value":"balance of trade",
       "description":"The net flow of goods into or out of a country for a given period. Net exports result in a surplus or credit; net exports result in a deficit or net debit."
    },
    {
       "key":64,
       "value":"balance sheet",
       "description":"A corporate report that shows a company’s financial condition at the time the balance sheet was created."
    },
    {
       "key":65,
       "value":"balance sheet equation",
       "description":"Assets = liabilities + shareholders equity."
    },
    {
       "key":66,
       "value":"balloon maturity",
       "description":"A bond maturity schedule that requires the largest portion of the principal to be repaid on the last maturity date."
    },
    {
       "key":67,
       "value":"bankers’ acceptance (BA)",
       "description":"A letter of credit that facilitates foreign trade. BAs are traded in the money market and have a maximum maturity of 270 days."
    },
    {
       "key":68,
       "value":"basis",
       "description":"The cost that is assigned to an asset."
    },
    {
       "key":69,
       "value":"basis book",
       "description":"A table used to calculate bond prices for bonds quoted on a yield basis and to calculate yields for bonds quoted on a price basis."
    },
    {
       "key":70,
       "value":"basis point",
       "description":"Measures a bond’s yield; 1 basis point is equal to 1/100 of 1%."
    },
    {
       "key":71,
       "value":"basis quote",
       "description":"A bond quote based on the bond’s yield."
    },
    {
       "key":72,
       "value":"bearer bond",
       "description":"A bond that is issued without the owner’s name being registered on the bond certificate or the books of the issuer. Whoever has possession of (bears) the certificate is deemed to be the rightful owner."
    },
    {
       "key":73,
       "value":"bearish",
       "description":"An investor’s belief that prices will decline."
    },
    {
       "key":74,
       "value":"bear market",
       "description":"A market condition that is characterized by continuing falling prices and a series of lower lows in overall prices."
    },
    {
       "key":75,
       "value":"best efforts underwriting",
       "description":"A type of underwriting that does not guarantee the issuer that any of its securities will be sold."
    },
    {
       "key":76,
       "value":"beta",
       "description":"A measure of a security’s or portfolio’s volatility relative to the market as a whole. A security or portfolio whose beta is greater than 1 will experience a greater change in price than overall market prices. A security or portfolio with a beta of less than 1 will experience a price change that is less than the price changes realized by the market as a whole."
    },
    {
       "key":77,
       "value":"bid",
       "description":"A price that an investor or broker dealer is willing to pay for a security. It is also a price at which an investor may sell a security immediately and the price at which a market maker will buy a security."
    },
    {
       "key":78,
       "value":"blind pool",
       "description":"A type of direct participation program where less than 75% of the assets to be acquired have been identified."
    },
    {
       "key":79,
       "value":"block trade",
       "description":"A trade involving 10,000 shares or market value of over $200,000."
    },
    {
       "key":80,
       "value":"blotter",
       "description":"A daily record of broker dealer transactions."
    },
    {
       "key":81,
       "value":"blue chip stock",
       "description":"Stock of a company whose earnings and dividends are stable regardless of the economy."
    },
    {
       "key":82,
       "value":"Blue List",
       "description":"A daily publication of municipal bond offerings and secondary market interest."
    },
    {
       "key":83,
       "value":"blue sky",
       "description":"A term used to describe the state registration process for a security offering."
    },
    {
       "key":84,
       "value":"blue-sky laws",
       "description":"Term used to describe the state-based laws enacted under the Uniform Securities Act."
    },
    {
       "key":85,
       "value":"board broker",
       "description":"See order book official."
    },
    {
       "key":86,
       "value":"board of directors",
       "description":"A group of directors elected by the stockholders of a corporation to appoint and oversee corporate management."
    },
    {
       "key":87,
       "value":"Board of Governors",
       "description":"The governing body of FINRA. The board is made up of 27 members elected by FINRA’s membership and the board itself."
    },
    {
       "key":88,
       "value":"bona fide quote",
       "description":"See firm quote."
    },
    {
       "key":89,
       "value":"bond",
       "description":"The legal obligation of a corporation or government to repay the principal amount of debt along with interest at a predetermined schedule."
    },
    {
       "key":90,
       "value":"bond anticipation note",
       "description":"Short-term municipal financing sold in anticipation of long-term financing."
    },
    {
       "key":91,
       "value":"bond buyer indexes",
       "description":"A group of yield-based municipal bond indexes published daily in the Daily Bond Buyer."
    },
    {
       "key":92,
       "value":"bond counsel",
       "description":"An attorney for the issuer of municipal securities who renders the legal opinion."
    },
    {
       "key":93,
       "value":"bond fund",
       "description":"A fund whose portfolio is made up of debt instruments issued by corporations, governments, and/or their agencies. The fund’s investment objective is usually current income."
    },
    {
       "key":94,
       "value":"bond interest coverage ratio",
       "description":"A measure of the issuer’s liquidity. It demonstrates how many times the issuer’s earnings will cover its bond interest expense."
    },
    {
       "key":95,
       "value":"bond quotes",
       "description":"Corporate and government bond quotes are based on a percentage of par. Municipal bonds are usually quoted on a yield-to-maturity basis."
    },
    {
       "key":96,
       "value":"bond rating",
       "description":"A rating that assesses the financial soundness of issuers and their ability to make interest and principal payments in a timely manner. Standard & Poor’s and Moody’s are the two largest ratings agencies. Issuers must request and pay for the service to rate their bonds."
    },
    {
       "key":97,
       "value":"bond ratio",
       "description":"A measure used to determine how much of the corporation’s capitalization was obtained through the issuance of bonds."
    },
    {
       "key":98,
       "value":"bond swap",
       "description":"The sale and purchase of two different bonds to allow the investor to claim a loss on the bond being sold without violating wash sale rules."
    },
    {
       "key":99,
       "value":"book entry",
       "description":"Securities that are issued in book entry form do not offer any physical certificates as evidence of ownership. The owner’s name is registered on the books of the issuer, and the only evidence of ownership is the trade confirmation."
    },
    {
       "key":100,
       "value":"book value",
       "description":"A corporation’s book value is the theoretical liquidation value of the company. Book value is in theory what someone would be willing to pay for the entire company."
    },
    {
       "key":101,
       "value":"book value per bond",
       "description":"A measure used to determine the amount of the corporation’s tangible value for each bond issued."
    },
    {
       "key":102,
       "value":"book value per share",
       "description":"Used to determine the tangible value of each common share. It is found by subtracting intangible assets and the par value of preferred stock from the corporation’s total net worth and dividing that figure by the number of common shares outstanding."
    },
    {
       "key":103,
       "value":"branch office",
       "description":"A branch office of a member firm is required to display the name of the member firm and is any office in which the member conducts securities business outside of its main office."
    },
    {
       "key":104,
       "value":"breadth",
       "description":"A measure of the broad market’s health. It measures how many stocks are increasing and how many are declining."
    },
    {
       "key":105,
       "value":"breakdown",
       "description":"A technical term used to describe the price action of a security when it falls below support to a lower level and into a new trading range."
    },
    {
       "key":106,
       "value":"breakeven point",
       "description":"The point at which the value of a security or portfolio is exactly equal to the investor’s cost for that security or portfolio."
    },
    {
       "key":107,
       "value":"breakout",
       "description":"A technical term used to describe the price action of a security when it increases past resistance to a higher level and into a new trading range."
    },
    {
       "key":108,
       "value":"breakpoint sale",
       "description":"The practice of selling mutual fund shares in dollar amounts that are just below the point where an investor would be entitled to a sales charge reduction. A breakpoint sale is designed for the purpose of trying to earn a larger commission. This is a violation of the Rules of Fair Practice and should never be done."
    },
    {
       "key":109,
       "value":"breakpoint schedule",
       "description":"A breakpoint schedule offers mutual fund investors reduced sales charges for larger dollar investments."
    },
    {
       "key":110,
       "value":"broad-based index",
       "description":"An index that represents a large cross-section of the market as a whole. The price movement of the index reflects the price movement of a large portion of the market, such as the S&P 500 or the Wilshire 5000."
    },
    {
       "key":111,
       "value":"broker",
       "description":"See agent."
    },
    {
       "key":112,
       "value":"broker dealer",
       "description":"A person or firm who buys and sells securities for its own account and for the accounts of others. When acting as a broker or agent for a customer, the broker dealer is merely executing the customer’s orders and charging the customer a fee known as a commission. When acting as a dealer or principal, the broker dealer is trading for its own account and participating in the customer’s transaction by taking the other side of the trade and charging the customer a markup or markdown. A firm also is acting as a principal or dealer when it is trading for its own account and making markets in OTC securities."
    },
    {
       "key":113,
       "value":"broker’s broker",
       "description":"(1) A municipal bond dealer who specializes in executing orders for other dealers who are not active in the municipal bond market. (2) A specialist on the exchange executing orders for other members or an OTC market."
    },
    {
       "key":114,
       "value":"bullish",
       "description":"An investor who believes that the price of a security or prices as a whole will rise is said to be bullish."
    },
    {
       "key":115,
       "value":"bull market",
       "description":"A market condition that is characterized by rising prices and a series of higher highs."
    },
    {
       "key":116,
       "value":"business cycle",
       "description":"The normal economic pattern that is characterized by four stages: expansion, peak, contraction, and trough. The business cycle constantly repeats itself and the economy is always in flux."
    },
    {
       "key":117,
       "value":"business day",
       "description":"The business day in the securities industry is defined as the time when the financial markets are open for trading."
    },
    {
       "key":118,
       "value":"buyer’s option",
       "description":"A settlement option that allows the buyer to determine when the transaction will settle."
    },
    {
       "key":119,
       "value":"buy in",
       "description":"An order executed in the event of a customer’s or firm’s failure to deliver the securities it sold. The buyer repurchases the securities in the open market and charges the seller for any loss."
    },
    {
       "key":120,
       "value":"buying power",
       "description":"The amount of money available to buy securities."
    },
    {
       "key":121,
       "value":"buy stop order",
       "description":"A buy stop order is used to protect against a loss or to protect a profit on a short sale of stock."
    },
    {
       "key":122,
       "value":"call",
       "description":"(1) A type of option that gives the holder the right to purchase a specified amount of the underlying security at a stated price for a specified period of time. (2) The act of exercising a call option."
    },
    {
       "key":123,
       "value":"callable bond",
       "description":"A bond that may be called in or retired by the issuer prior to its maturity date."
    },
    {
       "key":124,
       "value":"callable preferred",
       "description":"A preferred share issued with a feature allowing the issuing corporation to retire it under certain conditions."
    },
    {
       "key":125,
       "value":"call date",
       "description":"A specific date after which the securities in question become callable by the issuer."
    },
    {
       "key":126,
       "value":"call feature",
       "description":"A condition attached to some bonds and preferred stocks that allows the issuer to call in or redeem the securities prior to their maturity date and according to certain conditions."
    },
    {
       "key":127,
       "value":"call price",
       "description":"The price that will be paid by the issuer to retire the callable securities in question. The call price is usually set at a price above the par value of the bond or preferred stock, which is the subject of the call."
    },
    {
       "key":128,
       "value":"call protection",
       "description":"A period of time, usually right after the securities’ issuance, when the securities may not be called by the issuer. Call protection usually ranges from 5 to 10 years."
    },
    {
       "key":129,
       "value":"call provision",
       "description":"See call feature."
    },
    {
       "key":130,
       "value":"call risk",
       "description":"The risk borne by the owner of callable securities that may require that the investor accept a lower rate of return once the securities have been called. Callable bonds and preferred stock are more likely to be called when interest rates are low or are falling."
    },
    {
       "key":131,
       "value":"call spread",
       "description":"An option position consisting of one long and one short call on the same underlying security with different strike prices, expirations, or both."
    },
    {
       "key":132,
       "value":"call writer",
       "description":"An investor who has sold a call."
    },
    {
       "key":133,
       "value":"capital",
       "description":"Money and assets available to use in an attempt to earn more money or to accumulate more assets."
    },
    {
       "key":134,
       "value":"capital appreciation",
       "description":"An increase in an asset’s value over time."
    },
    {
       "key":135,
       "value":"capital assets",
       "description":"Tangible assets, including securities, real estate, equipment, and other assets, owned for the long term."
    },
    {
       "key":136,
       "value":"capital gain",
       "description":"A profit realized on the sale of an asset at a price that exceeds its cost."
    },
    {
       "key":137,
       "value":"capitalization",
       "description":"The composition of a company’s financial structure. It is the sum of paid-in capital + paid-in surplus + long-term debt + retained earnings."
    },
    {
       "key":138,
       "value":"capital loss",
       "description":"A loss realized on the sale of an asset at a price that is lower than its cost."
    },
    {
       "key":139,
       "value":"capital market",
       "description":"The securities markets that deal in equity and debt securities with more than 1 year to maturity."
    },
    {
       "key":140,
       "value":"capital risk",
       "description":"The risk that the value of an asset will decline and cause an investor to lose all or part of the invested capital."
    },
    {
       "key":141,
       "value":"capital stock",
       "description":"The sum of the par value of all of a corporation’s outstanding common and preferred stock."
    },
    {
       "key":142,
       "value":"capital surplus",
       "description":"The amount of money received by an issuer in excess of the par value of the stock at the time of its initial sale to the public."
    },
    {
       "key":143,
       "value":"capping",
       "description":"A manipulative practice of selling stock to depress the price."
    },
    {
       "key":144,
       "value":"carried interest",
       "description":"A sharing arrangement for an oil and gas direct participation program where the general partner shares in the tangible drilling costs with the limited partners."
    },
    {
       "key":145,
       "value":"cash account",
       "description":"An account in which the investor must deposit the full purchase price of the securities by the fourth business day after the trade date. The investor is not required by industry regulations to sign anything to open a cash account."
    },
    {
       "key":146,
       "value":"cash assets ratio",
       "description":"The most liquid measure of a company’s solvency. The cash asset ratio is found by dividing cash and equivalents by current liabilities."
    },
    {
       "key":147,
       "value":"cash dividend",
       "description":"The distribution of corporate profits to shareholders of record. Cash dividends must be declared by the company’s board of directors."
    },
    {
       "key":148,
       "value":"cash equivalent",
       "description":"Short-term liquid securities that can quickly be converted into cash. Money market instruments and funds are the most common examples."
    },
    {
       "key":149,
       "value":"cash flow",
       "description":"A company’s cash flow equals net income plus depreciation."
    },
    {
       "key":150,
       "value":"cashiering department",
       "description":"The department of a brokerage firm that is responsible for the receipt and delivery of cash and securities."
    },
    {
       "key":151,
       "value":"cash management bill",
       "description":"Short-term federal financing issued in minimum denominations of $10 million."
    },
    {
       "key":152,
       "value":"cash settlement",
       "description":"A transaction that settles for cash requires the delivery of the securities from the seller as well as the delivery of cash from the buyer on the same day of the trade. A trade done for cash settles the same day."
    },
    {
       "key":153,
       "value":"catastrophe call",
       "description":"The redemption of a bond by an issuer due to the destruction of the facility that was financed by the issue. Issuers will carry insurance to cover such events and to pay off the bondholders."
    },
    {
       "key":154,
       "value":"certificate of deposit (CD)",
       "description":"An unsecured promissory note issued as evidence of ownership of a time deposit that has been guaranteed by the issuing bank."
    },
    {
       "key":155,
       "value":"certificates of accrual on Treasury securities",
       "description":"Zero-coupon bonds issued by brokerage firms and collateralized by Treasury securities."
    },
    {
       "key":156,
       "value":"change",
       "description":"The difference between the current price and the previous day’s closing price."
    },
    {
       "key":157,
       "value":"Chicago Board of Trade (CBOT)",
       "description":"A commodity exchange that provides a marketplace for agricultural and financial futures."
    },
    {
       "key":158,
       "value":"Chicago Board Options Exchange (CBOE)",
       "description":"The premier option exchange in the United States for listed options."
    },
    {
       "key":159,
       "value":"Chinese wall",
       "description":"The physical separation that is required between investment banking and trading and retail divisions of a brokerage firm. Now known as a firewall."
    },
    {
       "key":160,
       "value":"churning",
       "description":"Executing transactions that are excessive in their frequency or size in light of the resources of the account for the purpose of generating commissions. Churning is a violation of the Rules of Fair Practice."
    },
    {
       "key":161,
       "value":"class A share",
       "description":"A mutual fund share that charges a front-end load."
    },
    {
       "key":162,
       "value":"class B share",
       "description":"A mutual fund share that charges a back-end load."
    },
    {
       "key":163,
       "value":"class C share",
       "description":"A mutual fund share that charges a level load."
    },
    {
       "key":164,
       "value":"class D share",
       "description":"A mutual fund share that charges a level load and a back-end load."
    },
    {
       "key":165,
       "value":"classical economics",
       "description":"A theory stating that the economy will do the best when the government does not interfere."
    },
    {
       "key":166,
       "value":"clearing firm",
       "description":"A firm that carries its customers’ cash and securities and/or provides the service to customers of other firms."
    },
    {
       "key":167,
       "value":"clearinghouse",
       "description":"An agency that guarantees and settles futures and option transactions."
    },
    {
       "key":168,
       "value":"close",
       "description":"The last price at which a security traded for the day."
    },
    {
       "key":169,
       "value":"closed-end indenture",
       "description":"A bond indenture that will not allow additional bonds to be issued with the same claim on the issuer’s assets."
    },
    {
       "key":170,
       "value":"closed-end investment company",
       "description":"A management company that issues a fixed number of shares to investors in a managed portfolio and whose shares are traded in the secondary market."
    },
    {
       "key":171,
       "value":"closing date",
       "description":"The date when sales of interest in a direct participation plan will cease."
    },
    {
       "key":172,
       "value":"closing purchase",
       "description":"An order executed to close out a short option position."
    },
    {
       "key":173,
       "value":"Code of Arbitration Procedure",
       "description":"The FINRA bylaw that provides for a forum for dispute resolution relating to industry matters. All industry participants must arbitrate in public and the customer must agree to arbitration in writing."
    },
    {
       "key":174,
       "value":"Code of Procedure",
       "description":"The FINRA bylaw that sets guidelines for the investigation of trade practice complaints and alleged rule violations."
    },
    {
       "key":175,
       "value":"coincident indicator",
       "description":"An economic indicator that moves simultaneously with the movement of the underlying economy."
    },
    {
       "key":176,
       "value":"collateral",
       "description":"Assets pledged to a lender. If the borrower defaults, the lender will take possession of the collateral."
    },
    {
       "key":177,
       "value":"collateral trust certificate",
       "description":"A bond backed by the pledge of securities the issuer owns in another entity."
    },
    {
       "key":178,
       "value":"collateralized mortgage obligation (CMO)",
       "description":"A corporate debt security that is secured by an underlying pool of mortgages."
    },
    {
       "key":179,
       "value":"collection ratio",
       "description":"A measure of a municipality’s ability to collect the taxes it has assessed."
    },
    {
       "key":180,
       "value":"collect on delivery (COD)",
       "description":"A method of trade settlement that requires the physical delivery of the securities to receive payment."
    },
    {
       "key":181,
       "value":"combination",
       "description":"An option position with a call and put on the same underlying security with different strike prices and expiration months on both."
    },
    {
       "key":182,
       "value":"combination fund",
       "description":"A mutual fund that tries to achieve growth and current income by combining portfolios of common stock with portfolios of high-yielding equities."
    },
    {
       "key":183,
       "value":"combination preferred stock",
       "description":"A preferred share with multiple features, such as cumulative and participating."
    },
    {
       "key":184,
       "value":"combination privileges",
       "description":"A feature offered by a mutual fund family that allows an investor to combine two simultaneous purchases of different portfolios in order to receive a reduced sales charge on the total amount invested."
    },
    {
       "key":185,
       "value":"combined account",
       "description":"A margin account that contains both long and short positions."
    },
    {
       "key":186,
       "value":"commercial paper",
       "description":"Short-term unsecured promissory notes issued by large financially stable corporations to obtain short-term financing. Commercial paper does not pay interest and is issued at a discount from its face value. All commercial paper matures in 270 days or less and matures at its face value."
    },
    {
       "key":187,
       "value":"commingling",
       "description":"A FINRA violation resulting from the mixing of customer and firm assets in the same account."
    },
    {
       "key":188,
       "value":"commission",
       "description":"A fee charged by a broker or agent for executing a securities transaction."
    },
    {
       "key":189,
       "value":"commission house broker",
       "description":"A floor broker who executes orders for the firm’s account and for the accounts of the firm’s customers on an exchange."
    },
    {
       "key":190,
       "value":"common stock",
       "description":"A security that represents the ownership of a corporation. Common stockholders vote to elect the board of directors and to institute major corporate policies."
    },
    {
       "key":191,
       "value":"common stock ratio",
       "description":"A measure of how much of a company’s capitalization was obtained through the sale of common stock. The ratio is found by summing the par value of the common stock, excess paid in capital, and retained earnings, and then dividing that number by the total capitalization."
    },
    {
       "key":192,
       "value":"competitive bid underwriting",
       "description":"A method of underwriter selection that solicits bids from multiple underwriters. The underwriter submitting the best terms will be awarded the issue."
    },
    {
       "key":193,
       "value":"compliance department",
       "description":"The department of a broker dealer that ensures that the firm adheres to industry rules and regulations."
    },
    {
       "key":194,
       "value":"concession",
       "description":"The amount of an underwriting discount that is allocated to a syndicate member or a selling group member for selling new securities."
    },
    {
       "key":195,
       "value":"conduct rules",
       "description":"The Rules of Fair Practice."
    },
    {
       "key":196,
       "value":"conduit theory",
       "description":"The IRS classification that allows a regulated investment company to avoid paying taxes on investment income it distributes to its shareholders."
    },
    {
       "key":197,
       "value":"confirmation",
       "description":"The receipt for a securities transaction that must be sent to all customers either on or before the completion of a transaction. The confirmation must show the trade date, settlement date, and total amount due to or from the customer. A transaction is considered to be complete on settlement date."
    },
    {
       "key":198,
       "value":"consolidated tape",
       "description":"The consolidated tape A displays transactions for NYSE securities that take place on the NYSE, all regional exchanges, and the third markets. The consolidated tape B reports transactions for AMEX stocks that take place on the American Stock Exchange, all regional exchanges, and in the third market."
    },
    {
       "key":199,
       "value":"consolidation",
       "description":"A chart pattern that results from a narrowing of a security’s trading range."
    },
    {
       "key":200,
       "value":"constant dollar plan",
       "description":"An investment plan designed to keep a specific amount of money invested in the market regardless of the market’s condition. An investor will sell when the value of the account rises and buy when the value of the account falls."
    },
    {
       "key":201,
       "value":"constant ratio plan",
       "description":"An investment plan designed to keep the investor’s portfolio invested at a constant ratio of equity and debt securities."
    },
    {
       "key":202,
       "value":"construction loan note",
       "description":"A short-term municipal note designed to provide financing for construction projects."
    },
    {
       "key":203,
       "value":"constructive receipt",
       "description":"The time when the IRS determines that the taxpayer has effectively received payment."
    },
    {
       "key":204,
       "value":"consumer price index (CPI)",
       "description":"A price-based index made up of a basket of goods and services that are used by consumers in their daily lives. An increase in the CPI indicates a rise in overall prices, while a decline in the index represents a fall in overall prices."
    },
    {
       "key":205,
       "value":"consumption",
       "description":"A term used to describe the purchase of newly produced household goods."
    },
    {
       "key":206,
       "value":"contemporaneous trader",
       "description":"A trader who enters an order on the other side of the market at the same time as a trader with inside information enters an order. Contemporaneous traders can sue traders who act on inside information to recover losses."
    },
    {
       "key":207,
       "value":"contingent deferred sales charge",
       "description":"See back-end load."
    },
    {
       "key":208,
       "value":"contraction",
       "description":"A period of declining economic output. Also known as a recession."
    },
    {
       "key":209,
       "value":"contractual plan",
       "description":"A mutual fund accumulation plan under which the investor agrees to contribute a fixed sum of money over time. If the investor does not complete or terminates the contract early, the investor may be subject to penalties."
    },
    {
       "key":210,
       "value":"control",
       "description":"The ability to influence the actions of an organization or individual."
    },
    {
       "key":211,
       "value":"control person",
       "description":"A director or officer of an issuer or broker dealer or a 10% stockholder of a corporation."
    },
    {
       "key":212,
       "value":"control stock",
       "description":"Stock that is acquired or owned by an officer, director, or person owning 10% or more of the outstanding stock of a company."
    },
    {
       "key":213,
       "value":"conversion price",
       "description":"The set price at which a convertible security may be exchanged for another security."
    },
    {
       "key":214,
       "value":"conversion privilege",
       "description":"The right offered to a mutual fund investor that allows the investor to move money between different portfolios offered by the same mutual fund family without paying another sales charge."
    },
    {
       "key":215,
       "value":"conversion ratio",
       "description":"The number of shares that can be received by the holder of a convertible security if it were converted into the underlying common stock."
    },
    {
       "key":216,
       "value":"convertible bond",
       "description":"A bond that may be converted or exchanged for common shares of the corporation at a predetermined price."
    },
    {
       "key":217,
       "value":"convertible preferred stock",
       "description":"A preferred stock that may be converted or exchanged for common shares of the corporation at a predetermined price."
    },
    {
       "key":218,
       "value":"cooling-off period",
       "description":"The period of time between the filing of a registration statement and its effective date. During this time, the SEC is reviewing the registration statement and no sales may take place. The cooling-off period is at least 20 days."
    },
    {
       "key":219,
       "value":"coordination",
       "description":"A method of securities registration during which a new issue is registered simultaneously at both the federal and state levels."
    },
    {
       "key":220,
       "value":"corporate account",
       "description":"An investment account for the benefit of a company that requires a corporate resolution listing the names of individuals who may transact business in the company’s name."
    },
    {
       "key":221,
       "value":"corporate bond",
       "description":"A legally binding obligation of a corporation to repay a principal amount of debt along with interest at a predetermined rate and schedule."
    },
    {
       "key":222,
       "value":"corporation",
       "description":"A perpetual entity that survives after the death of its officers, directors, and stockholders. It is the most common form of business entity."
    },
    {
       "key":223,
       "value":"correspondent broker dealer",
       "description":"A broker dealer who introduces customer accounts to a clearing broker dealer."
    },
    {
       "key":224,
       "value":"cost basis",
       "description":"The cost of an asset, including any acquisition costs. It is used to determine capital gains and losses."
    },
    {
       "key":225,
       "value":"cost depletion",
       "description":"A method used to determine the tax deductions for investors in oil and gas programs."
    },
    {
       "key":226,
       "value":"cost of carry",
       "description":"All costs incurred by an investor for maintaining a position in a security, including margin interest and opportunity costs."
    },
    {
       "key":227,
       "value":"coterminous",
       "description":"Municipalities that share the same borders and have overlapping debt."
    },
    {
       "key":228,
       "value":"coupon bond",
       "description":"See bearer bond."
    },
    {
       "key":229,
       "value":"coupon yield",
       "description":"See nominal yield."
    },
    {
       "key":230,
       "value":"covenant",
       "description":"A promise made by an issuer of debt that describes the issuer’s obligations and the bondholders’ rights."
    },
    {
       "key":231,
       "value":"covered call",
       "description":"The sale of a call against a long position in the underlying security."
    },
    {
       "key":232,
       "value":"covered put",
       "description":"The sale of a put against a short position in the underlying security or against cash that will allow the person to purchase the security if the put is exercised."
    },
    {
       "key":233,
       "value":"CPI",
       "description":"See consumer price index (CPI)."
    },
    {
       "key":234,
       "value":"credit agreement",
       "description":"The portion of the margin agreement that describes the terms and conditions under which credit will be extended to the customer."
    },
    {
       "key":235,
       "value":"credit balance",
       "description":"The cash balance in a customer’s account."
    },
    {
       "key":236,
       "value":"credit department",
       "description":"See margin department."
    },
    {
       "key":237,
       "value":"credit risk",
       "description":"The risk that the issuer of debt securities will default on its obligation to pay interest or principal on a timely basis."
    },
    {
       "key":238,
       "value":"credit spread",
       "description":"An option position that results in a net premium or credit received by the investor from the simultaneous purchase and sale of two calls or two puts on the same security."
    },
    {
       "key":239,
       "value":"crossed market",
       "description":"A market condition that results when a broker enters a bid for a stock that exceeds the offering price for that stock. Also a condition that may result when a broker enters an offer that is lower than the bid price for that stock."
    },
    {
       "key":240,
       "value":"crossing stock",
       "description":"The pairing off of two offsetting customer orders by the same floor broker. The floor broker executing the cross must first show the order to the crowd for possible price improvement before crossing the orders."
    },
    {
       "key":241,
       "value":"crossover point",
       "description":"The point at which all tax credits have been used up by a limited partnership; results in a tax liability for the partners."
    },
    {
       "key":242,
       "value":"cum rights",
       "description":"A stock that is the subject of a rights offering and is trading with the rights attached to the common stock."
    },
    {
       "key":243,
       "value":"cumulative preferred stock",
       "description":"A preferred stock that entitles the holder to receive unpaid dividends prior to the payment of any dividends to common stockholders. Dividends that accumulate in arrears on cumulative issues are always the first dividends to be paid by a corporation."
    },
    {
       "key":244,
       "value":"cumulative voting",
       "description":"A method of voting that allows stockholders to cast all of their votes for one director or to distribute them among the candidates they wish to vote for. Cumulative voting favors smaller investors by allowing them to have a larger say in the election of the board of directors."
    },
    {
       "key":245,
       "value":"current assets",
       "description":"Cash, securities, accounts receivable, and other assets that can be converted into cash within 12 months."
    },
    {
       "key":246,
       "value":"current liabilities",
       "description":"Corporate obligations, including accounts payable, that must be paid within 12 months."
    },
    {
       "key":247,
       "value":"current market value (CMV)/current market price (CMP)",
       "description":"The present value of a marketable security or of a portfolio of marketable securities."
    },
    {
       "key":248,
       "value":"current ratio",
       "description":"A measure of a corporation’s short-term liquidity found by dividing its current assets by its current liabilities."
    },
    {
       "key":249,
       "value":"current yield",
       "description":"A relationship between a securities annual income relative to its current market price. Determined by dividing annual income by the current market price."
    },
    {
       "key":250,
       "value":"CUSIP (Committee on Uniform Securities Identification Procedures)",
       "description":"A committee that assigns identification numbers to securities to help identify them."
    },
    {
       "key":251,
       "value":"custodial account",
       "description":"An account operated by a custodian for the benefit of a minor."
    },
    {
       "key":252,
       "value":"custodian",
       "description":"A party responsible for managing an account for another party. In acting as a custodian, the individual or corporation must adhere to the prudent man rule and only take such actions as a prudent person would do for himor herself."
    },
    {
       "key":253,
       "value":"customer",
       "description":"Any individual or entity that maintains an account with a broker dealer."
    },
    {
       "key":254,
       "value":"customer agreement",
       "description":"An agreement signed by a customer at the time the account is opened, detailing the conditions of the customer’s relationship with the firm. The customer agreement usually contains a predispute arbitration clause."
    },
    {
       "key":255,
       "value":"customer ledger",
       "description":"A ledger that lists all customer cash and margin accounts."
    },
    {
       "key":256,
       "value":"customer protection rule",
       "description":"Rule 15C3-3 requires that customer assets be kept segregated from the firm assets."
    },
    {
       "key":257,
       "value":"cyclical industry",
       "description":"An industry whose prospects fluctuate with the business cycle."
    },
    {
       "key":258,
       "value":"Daily Bond Buyer",
       "description":"A daily publication for the municipal securities industry that publishes information related to the municipal bond market and official notices of sales."
    },
    {
       "key":259,
       "value":"dated date",
       "description":"The day when interest starts to accrue for bonds."
    },
    {
       "key":260,
       "value":"dealer",
       "description":"(1) A person or firm who transacts securities business for its own account. (2) A brokerage firm acting as a principal when executing a customer’s transaction or making markets over the counter."
    },
    {
       "key":261,
       "value":"dealer paper",
       "description":"Commercial paper sold to the public by a dealer, rather than placed with investors directly by the issuer."
    },
    {
       "key":262,
       "value":"debenture",
       "description":"An unsecured promissory note issued by a corporation backed only by the issuer’s credit and promise to pay."
    },
    {
       "key":263,
       "value":"debit balance",
       "description":"The amount of money a customer owes a broker dealer."
    },
    {
       "key":264,
       "value":"debit spread",
       "description":"An option position that results in a net premium paid by the investor from the simultaneous purchase and sale of two calls or two puts on the same security."
    },
    {
       "key":265,
       "value":"debt securities",
       "description":"A security that represents a loan to the issuer. The owner of a debt security is a creditor of the issuing entity, be it a corporation or a government."
    },
    {
       "key":266,
       "value":"debt service",
       "description":"The scheduled interest payments and repayment of principal for debt securities."
    },
    {
       "key":267,
       "value":"debt service account",
       "description":"An account set up by a municipal issuer to pay the debt service of municipal revenue bonds."
    },
    {
       "key":268,
       "value":"debt service ratio",
       "description":"Indicates the issuer’s ability to pay its interest and principal payments."
    },
    {
       "key":269,
       "value":"debt-to-equity ratio",
       "description":"A ratio that shows how highly leveraged the company is. It is found by dividing total long-term debt by total shareholder equity."
    },
    {
       "key":270,
       "value":"declaration date",
       "description":"The day chosen by the board of directors of a corporation to pay a dividend to shareholders."
    },
    {
       "key":271,
       "value":"deduction",
       "description":"An adjustment taken from gross income to reduce tax liability."
    },
    {
       "key":272,
       "value":"default",
       "description":"The failure of an issuer of debt securities to make interest and principal payments when they are due."
    },
    {
       "key":273,
       "value":"default risk",
       "description":"See credit risk."
    },
    {
       "key":274,
       "value":"defeasance",
       "description":"Results in the elimination of the issuer’s debt obligations by issuing a new debt instrument to pay off the outstanding issue. The old issue is removed from the issuer’s balance sheet and the proceeds of the new issue are placed in an escrow account to pay off the now-defeased issue."
    },
    {
       "key":275,
       "value":"defensive industry",
       "description":"A term used to describe a business whose economic prospects are independent from the business cycle. Pharmaceutical companies, utilities, and food producers are examples of defensive industries."
    },
    {
       "key":276,
       "value":"deferred annuity",
       "description":"A contract between an individual and an insurance company that delays payments to the annuitant until some future date."
    },
    {
       "key":277,
       "value":"deferred compensation plan",
       "description":"A contractual agreement between an employer and an employee under which the employee elects to defer receiving money owed until after retirement. Deferred compensation plans are typically unfunded, and the employee could lose all the money due under the agreement if the company goes out of business."
    },
    {
       "key":278,
       "value":"deficiency letter",
       "description":"A letter sent to a corporate issuer by the SEC, requesting additional information regarding the issuer’s registration statement."
    },
    {
       "key":279,
       "value":"defined benefit plan",
       "description":"A qualified retirement plan established to provide a specific amount of retirement income for the plan participants. Unlike a defined contribution plan, the individual’s retirement benefits are known prior to reaching retirement."
    },
    {
       "key":280,
       "value":"defined contribution plan",
       "description":"A qualified retirement plan that details the amount of money that the employer will contribute to the plan for the benefit of the employee. This amount is usually expressed as a percentage of the employee’s gross annual income. The actual retirement benefits are not known until the employee reaches retirement, and the amount of the retirement benefit is a result of the contributions to the plan, along with the investment experience of the plan."
    },
    {
       "key":281,
       "value":"deflation",
       "description":"The economic condition that is characterized by a persistent decline in overall prices."
    },
    {
       "key":282,
       "value":"delivery",
       "description":"As used in the settlement process, results in the change of ownership of cash or securities."
    },
    {
       "key":283,
       "value":"delivery vs. payment",
       "description":"A type of settlement option that requires that the securities be physically received at the time payment is made."
    },
    {
       "key":284,
       "value":"delta",
       "description":"A measure of an option’s price change in relation to a price change in the underlying security."
    },
    {
       "key":285,
       "value":"demand deposit",
       "description":"A deposit that a customer has with a bank or other financial institution that will allow the customer to withdraw the money at any time or on demand."
    },
    {
       "key":286,
       "value":"Department of Enforcement",
       "description":"The FINRA committee that has original jurisdiction over complaints and violations."
    },
    {
       "key":287,
       "value":"depletion",
       "description":"A tax deduction taken for the reduction in the amount of natural resources (e.g., gas, gold, oil) available to a business or partnership."
    },
    {
       "key":288,
       "value":"depreciation",
       "description":"A tax deduction taken for the reduction of value in a capital asset."
    },
    {
       "key":289,
       "value":"depreciation expense",
       "description":"A noncash expense that results in a reduction in taxable income."
    },
    {
       "key":290,
       "value":"depression",
       "description":"An economic condition that is characterized by a protracted decline in economic output and a rising level of unemployment."
    },
    {
       "key":291,
       "value":"derivative",
       "description":"A security that derives its value in whole or in part based on the price of another security. Options and futures are examples of derivative securities."
    },
    {
       "key":292,
       "value":"designated order",
       "description":"An order entered by an institution for a new issue of municipal bonds that states what firm and what agent is going to get the sales credit for the order."
    },
    {
       "key":293,
       "value":"devaluation",
       "description":"A significant fall in the value of a country’s currency relative to other currencies. Devaluation could be the result of poor economic prospects in the home country. In extreme circumstances, it can be the result of government intervention."
    },
    {
       "key":294,
       "value":"developmental drilling program",
       "description":"An oil or gas program that drills for wells in areas of proven reserves."
    },
    {
       "key":295,
       "value":"developmental fee",
       "description":"A fee paid to organizers of a direct participation plan for the development of plans, obtaining financing or zoning authorizations, and other services."
    },
    {
       "key":296,
       "value":"diagonal spread",
       "description":"A spread that is created through the simultaneous purchase and sale of two calls or two puts on the same underlying security that differ in both strike price and expiration months."
    },
    {
       "key":297,
       "value":"dilution",
       "description":"A reduction in a stockholder’s proportional ownership of a corporation as a result of the issuance of more shares. Earnings per share may also be diluted as a result of the issuance of additional shares."
    },
    {
       "key":298,
       "value":"direct debt",
       "description":"The total amount of a municipality’s debt that has been issued by the municipality for its own benefit and for which the municipality is responsible to repay."
    },
    {
       "key":299,
       "value":"direct paper",
       "description":"Commercial paper sold to investors directly from the issuer without the use of a dealer."
    },
    {
       "key":300,
       "value":"direct participation program (DPP)",
       "description":"An entity that allows all taxable events to be passed through to investors, including limited partnerships and subchapter S corporations."
    },
    {
       "key":301,
       "value":"discount",
       "description":"The amount by which the price of a security is lower than its par value."
    },
    {
       "key":302,
       "value":"discount bond",
       "description":"A bond that is selling for a price that is lower than its par value."
    },
    {
       "key":303,
       "value":"discount rate",
       "description":"The rate that is charged to Federal Reserve member banks on loans directly from the Federal Reserve. This rate is largely symbolic, and member banks only borrow directly from the Federal Reserve as a last resort."
    },
    {
       "key":304,
       "value":"discretion",
       "description":"Authorization given to a firm or a representative to determine which securities are to be purchased and sold for the benefit of the customer without the customer’s prior knowledge or approval."
    },
    {
       "key":305,
       "value":"discretionary account",
       "description":"An account where the owner has given the firm or the representative authority to transact business without the customer’s prior knowledge or approval. All discretionary accounts must be approved and monitored closely by a principal of the firm."
    },
    {
       "key":306,
       "value":"disintermediation",
       "description":"The flow of money from traditional bank accounts to alternative higher yielding investments. This is more likely to occur as the Federal Reserve tightens monetary policy and interest rates rise."
    },
    {
       "key":307,
       "value":"disposable income",
       "description":"The sum of money an individual has left after paying taxes and required expenditures."
    },
    {
       "key":308,
       "value":"disproportional allocation",
       "description":"A method used by FINRA to determine if a free-riding violation has occurred with respect to a hot issuer. A firm is only allowed to sell up to 10% of a new issue to conditionally approved purchasers."
    },
    {
       "key":309,
       "value":"disproportionate sharing",
       "description":"An oil and gas sharing arrangement where the general partner pays a portion of the cost but receives a larger portion of the program’s revenues."
    },
    {
       "key":310,
       "value":"distribution",
       "description":"Cash or property sent to shareholders or partners."
    },
    {
       "key":311,
       "value":"distribution stage",
       "description":"The period of time during which an annuitant is receiving payments from an annuity contract."
    },
    {
       "key":312,
       "value":"diversification",
       "description":"The distribution of investment capital among different investment choices. By purchasing several different investments, investors may be able to reduce their overall risk by minimizing the impact of any one security’s adverse performance."
    },
    {
       "key":313,
       "value":"diversified fund/diversified management company",
       "description":"A mutual fund that distributes its investment capital among a wide variety of investments. In order for a mutual fund to market itself as a diversified mutual fund it must meet the 75-5-10 rule: 75% of the fund’s assets must be invested in securities issued by other entities, no more than 5% of the fund’s assets may be invested in any one issuer, and the fund may own no more than 10% of any one company’s outstanding securities."
    },
    {
       "key":314,
       "value":"dividend",
       "description":"A distribution of corporate assets to shareholders. A dividend may be paid in cash, stock, or property or product."
    },
    {
       "key":315,
       "value":"dividend department",
       "description":"The department in a brokerage firm that is responsible for the collecting of dividends and crediting them to customer accounts."
    },
    {
       "key":316,
       "value":"dividend disbursement agent",
       "description":"An agent of the issuer who pays out the dividends to shareholders of record."
    },
    {
       "key":317,
       "value":"dividend payout ratio",
       "description":"The amount of a company’s earnings that were paid out to shareholders relative to the total earnings that were available to be paid out to shareholders. It can be calculated by dividing dividends per share by earnings per share."
    },
    {
       "key":318,
       "value":"dividend yield",
       "description":"Also known as a stock’s current yield. It is a relationship between the annual dividends paid to shareholders relative to the stock’s current market price. To determine a stock’s dividend yield, divide annual dividends by the current market price."
    },
    {
       "key":319,
       "value":"DJIA",
       "description":"See Dow Jones Industrial Average."
    },
    {
       "key":320,
       "value":"doctrine of mutual reciprocity",
       "description":"An agreement that the federal government would not tax interest income received by investors in municipal bonds and that reciprocally the states would not tax interest income received by investors in federal debt obligations."
    },
    {
       "key":321,
       "value":"dollar bonds",
       "description":"A term issue of municipal bonds that are quoted as a percentage of par rather than on a yield basis."
    },
    {
       "key":322,
       "value":"dollar-cost averaging",
       "description":"A strategy of investing a fixed sum of money on a regular basis into a fluctuating market price. Over time an investor should be able to achieve an average cost per share that is below the average price per share. Dollar-cost averaging is a popular investment strategy with mutual fund investors."
    },
    {
       "key":323,
       "value":"donor",
       "description":"A person who gives a gift of cash or securities to another person. Once the gift has been made, the donor no longer has any rights or claim to the security. All gifts to a minor are irrevocable."
    },
    {
       "key":324,
       "value":"do not reduce (DNR)",
       "description":"An order qualifier for an order placed under the market that stipulates that the price of the order is not to be reduced for the distribution of ordinary dividends."
    },
    {
       "key":325,
       "value":"don’t know (DK)",
       "description":"A term used to describe a dealer’s response to a confirmation for a trade they “don’t know” doing."
    },
    {
       "key":326,
       "value":"Dow Jones Composite Average",
       "description":"A priced based index composed of 65 stocks that is used as an indicator of market performance."
    },
    {
       "key":327,
       "value":"Dow Jones Industrial Average (DJIA)",
       "description":"A price based  index composed of 30 industrial companies. The Dow Jones is the most widely quoted market index."
    },
    {
       "key":328,
       "value":"Dow Jones Transportation Average",
       "description":"An index composed of 20 transportation stocks."
    },
    {
       "key":329,
       "value":"Dow Jones Utility Average",
       "description":"An index composed of 15 utility stocks."
    },
    {
       "key":330,
       "value":"Dow theory",
       "description":"A theory that believes that the health of both the market and of the economy may be predicted by the performance of the Dow Jones Industrial Average."
    },
    {
       "key":331,
       "value":"dry hole",
       "description":"A term used to describe a non producing well."
    },
    {
       "key":332,
       "value":"dual-purpose fund",
       "description":"A mutual fund that offers two classes of shares to investors. One class is sold to investors seeking income and the other class is sold to investors seeking capital appreciation."
    },
    {
       "key":333,
       "value":"early withdrawal penalty",
       "description":"A penalty tax charged to an investor for withdrawing money from a qualified retirement plan prior to age 59-1/2, usually 10% on top of ordinary income taxes."
    },
    {
       "key":334,
       "value":"earned income",
       "description":"Money received by an individual in return for performing services."
    },
    {
       "key":335,
       "value":"earnings per share",
       "description":"The net amount of a corporation’s earnings available to common shareholders divided by the number of common shares outstanding."
    },
    {
       "key":336,
       "value":"earnings per share fully diluted",
       "description":"The net amount of a corporation’s earnings available to common shareholders after taking into consideration the potential conversion of all convertible securities."
    },
    {
       "key":337,
       "value":"eastern account",
       "description":"A type of syndicate account that requires all members to be responsible for their own allocation as well as for their proportional share of any member’s unsold securities."
    },
    {
       "key":338,
       "value":"economic risk",
       "description":"The risk of loss of principal associated with the purchase of securities."
    },
    {
       "key":339,
       "value":"EE savings bonds",
       "description":"Non Marketable U.S. government zero-coupon bonds that must be purchased from the government and redeemed to the government."
    },
    {
       "key":340,
       "value":"effective date",
       "description":"The day when a new issue’s registration with the SEC becomes effective. Once the issue’s registration statement has become effective, the securities may then be sold to investors."
    },
    {
       "key":341,
       "value":"efficient market theory",
       "description":"A theory that states that the market operates and processes information efficiently and prices in all information as soon as it becomes known."
    },
    {
       "key":342,
       "value":"Employee Retirement Income Security Act of 1974 (ERISA)",
       "description":"The legislation that governs the operation of private-sector pension plans. Corporate pension plans organized under ERISA guidelines qualify for beneficial tax treatment by the IRS."
    },
    {
       "key":343,
       "value":"endorsement",
       "description":"The signature on the back of a security that allows its ownership to be transferred."
    },
    {
       "key":344,
       "value":"EPS",
       "description":"See earnings per share."
    },
    {
       "key":345,
       "value":"equipment leasing limited partnership",
       "description":"A limited partnership that is organized to purchase equipment and lease it to corporations to earn lease income and to shelter passive income for investors."
    },
    {
       "key":346,
       "value":"equipment trust certificate",
       "description":"A bond backed by a pledge of large equipment, such as airplanes, railroad cars, and ships."
    },
    {
       "key":347,
       "value":"equity",
       "description":"A security that represents the ownership in a corporation. Both preferred and common equity holders have an ownership interest in the corporation."
    },
    {
       "key":348,
       "value":"equity financing",
       "description":"The sale of common or preferred equity by a corporation in an effort to raise capital."
    },
    {
       "key":349,
       "value":"equity option",
       "description":"An option to purchase or sell common stock."
    },
    {
       "key":350,
       "value":"ERISA",
       "description":"See Employee Retirement Income Security Act of 1974."
    },
    {
       "key":351,
       "value":"erroneous report",
       "description":"A report of an execution given in error to a client. The report is not binding on the firm or on the agent."
    },
    {
       "key":352,
       "value":"escrow agreement",
       "description":"Evidence of ownership of a security provided to a broker dealer as proof of ownership of the underlying security for covered call writers."
    },
    {
       "key":353,
       "value":"Eurobond",
       "description":"A bond issued in domestic currency of the issuer but sold outside of the issuer’s country."
    },
    {
       "key":354,
       "value":"Eurodollar",
       "description":"A deposit held outside of the United States denominated in U.S. dollars."
    },
    {
       "key":355,
       "value":"Eurodollar bonds",
       "description":"A bond issued by a foreign issuer denominated in U.S. dollars."
    },
    {
       "key":356,
       "value":"Euroyen bonds",
       "description":"Bonds issued outside of Japan but denominated in yen."
    },
    {
       "key":357,
       "value":"excess equity (EE)",
       "description":"The value of an account’s equity in excess of Regulation T."
    },
    {
       "key":358,
       "value":"exchange",
       "description":"A market, whether physical or electronic, that provides a forum for trading securities through a dual-auction process."
    },
    {
       "key":359,
       "value":"exchange distribution",
       "description":"A distribution of a large block of stock on the floor of the exchange that is crossed with offsetting orders."
    },
    {
       "key":360,
       "value":"exchange privilege",
       "description":"The right offered by many mutual funds that allows an investor to transfer or move money between different portfolios offered through the same fund company. <br>An investor may redeem shares of the fund, which is being sold at the NAV, and purchase shares of the new portfolio at the NAV without paying another sales charge."
    },
    {
       "key":361,
       "value":"ex date/ex-dividend date",
       "description":"The first day when purchasers of a security will no longer be entitled to receive a previously declared dividend."
    },
    {
       "key":362,
       "value":"executor/executrix",
       "description":"An individual with the authority to manage the affairs of a decedent’s estate."
    },
    {
       "key":363,
       "value":"exempt security",
       "description":"A security that is exempt from the registration requirements of the Securities Act of 1933."
    },
    {
       "key":364,
       "value":"exempt transaction",
       "description":"A transaction that is not subject to state registration."
    },
    {
       "key":365,
       "value":"exercise",
       "description":"An investor’s election to take advantage of the rights offered through the terms of an option, a right, or a warrant."
    },
    {
       "key":366,
       "value":"exercise price",
       "description":"The price at which an option investor may purchase or sell a security. Also the price at which an investor may purchase a security through a warrant or right."
    },
    {
       "key":367,
       "value":"existing property program",
       "description":"A type of real estate direct participation program that purchases existing property for the established rental income."
    },
    {
       "key":368,
       "value":"expansion",
       "description":"A period marked by a general increase in business activity and an increase in gross domestic product."
    },
    {
       "key":369,
       "value":"expansionary policy",
       "description":"A monetary policy enacted through the Federal Reserve Board that in-creases money supply and reduces interest rates in an effort to stimulate the economy."
    },
    {
       "key":370,
       "value":"expense ratio",
       "description":"The amount of a mutual fund’s expenses relative to its assets. The higher the expense ratio, the lower the investor’s return. A mutual fund’s expense ratio tells an investor how efficiently a mutual fund operates, not how profitable the mutual fund is."
    },
    {
       "key":371,
       "value":"expiration cycle",
       "description":"A 4-month cycle for option expiration: January, April, July, and October; February, May, August, and November; or March, June, September, and December."
    },
    {
       "key":372,
       "value":"expiration date",
       "description":"The date on which an option ceases to exist."
    },
    {
       "key":373,
       "value":"exploratory drilling program",
       "description":"A direct participation program that engages in the drilling for oil or gas in new areas seeking to find new wells."
    },
    {
       "key":374,
       "value":"exploratory well",
       "description":"Also known as wildcatting. The drilling for oil or gas in new areas in an effort to find new wells."
    },
    {
       "key":375,
       "value":"ex rights",
       "description":"The common stock subject to a rights offering trading without the rights attached."
    },
    {
       "key":376,
       "value":"ex rights date",
       "description":"The first day when the common stock is subject to a rights offering trade without the rights attached."
    },
    {
       "key":377,
       "value":"ex warrants",
       "description":"Common trading without the warrants attached."
    },
    {
       "key":378,
       "value":"face-amount certificate company (FAC)",
       "description":"A type of investment company that requires an investor to make fixed payments over time or to deposit a lump sum, and that will return to the investor a stated sum known as the face amount on a specific date."
    },
    {
       "key":379,
       "value":"face amount/face value",
       "description":"See par."
    },
    {
       "key":380,
       "value":"fail to deliver",
       "description":"An event where the broker on the sell side of the transaction fails to deliver the security."
    },
    {
       "key":381,
       "value":"fail to receive",
       "description":"An event where the broker on the buy side of the transaction fails to receive the security from the broker on the sell side."
    },
    {
       "key":382,
       "value":"Fannie Mae",
       "description":"See Federal National Mortgage Association."
    },
    {
       "key":383,
       "value":"Farm Credit Administrator",
       "description":"The agency that oversees all of the activities of the banks in the Federal Farm Credit System."
    },
    {
       "key":384,
       "value":"Federal Deposit Insurance Corporation (FDIC)",
       "description":"The government insurance agency that provides insurance for bank depositors in case of bank failure."
    },
    {
       "key":385,
       "value":"Federal Farm Credit System",
       "description":"An organization of banks that is designed to provide financing to farmers for mortgages, feed and grain, and equipment."
    },
    {
       "key":386,
       "value":"federal funds rate",
       "description":"The rate banks charge each other on overnight loans."
    },
    {
       "key":387,
       "value":"Federal Home Loan Mortgage Corporation (FHLMC; Freddie Mac)",
       "description":"A publicly traded for-profit corporation that provides liquidity to the secondary mortgage market by purchasing pools of mortgages from lenders and, in turn, issues mortgage-backed securities."
    },
    {
       "key":388,
       "value":"Federal Intermediate Credit Bank",
       "description":"Provides short-term financing to farmers for equipment."
    },
    {
       "key":389,
       "value":"Federal National Mortgage Association (FNMA; Fannie Mae)",
       "description":"A publicly traded for-profit corporation that provides liquidity to the secondary mortgage market by purchasing pools of mortgages and issuing mortgage-backed securities."
    },
    {
       "key":390,
       "value":"Federal Open Market Committee (FOMC)",
       "description":"The committee of the Federal Reserve Board that makes policy decisions relating to the nation’s money supply."
    },
    {
       "key":391,
       "value":"Federal Reserve Board",
       "description":"A seven-member board that directs the policies of the Federal Reserve System. The members are appointed by the President and approved by Congress."
    },
    {
       "key":392,
       "value":"Federal Reserve System",
       "description":"The nation’s central banking system, the purpose of which is to regulate money supply and the extension of credit. The Federal Reserve System is composed of 12 central banks and 24 regional banks, along with hundreds of national and state chartered banks."
    },
    {
       "key":393,
       "value":"fictitious quote",
       "description":"A quote that is not representative of an actual bid or offer for a security."
    },
    {
       "key":394,
       "value":"fidelity bond",
       "description":"A bond that must be posted by all broker dealers to ensure the public against employee dishonesty."
    },
    {
       "key":395,
       "value":"fill or kill (FK)",
       "description":"A type of order that requires that all of the securities in the order be purchased or sold immediately or not at all."
    },
    {
       "key":396,
       "value":"final prospectus",
       "description":"The official offering document for a security that contains the security’s final offering price along with all information required by law for an investor to make an informed decision."
    },
    {
       "key":397,
       "value":"firm commitment underwriting",
       "description":"Guarantees the issuer all of the money right away. The underwriters purchase all of the securities from the issuer regardless of whether they can sell the securities to their customers."
    },
    {
       "key":398,
       "value":"firm quote",
       "description":"A quote displayed at which the dealer is obligated to buy or sell at least one round lot at the quoted price."
    },
    {
       "key":399,
       "value":"fiscal policy",
       "description":"Government policy designed to influence the economy through government tax and spending programs. The President and Congress control fiscal policy."
    },
    {
       "key":400,
       "value":"5% markup policy",
       "description":"FINRA’s guideline that requires all prices paid by customers to be reasonably related to a security’s market price. The 5% policy is a guideline, not a rule, and it does not apply to securities sold through a prospectus."
    },
    {
       "key":401,
       "value":"fixed annuity",
       "description":"An insurance contract where the insurance company guarantees fixed payments to the annuitant, usually until the annuitant’s death."
    },
    {
       "key":402,
       "value":"fixed assets",
       "description":"Assets used by a corporation to conduct its business, such as plant and equipment."
    },
    {
       "key":403,
       "value":"flat",
       "description":"A term used to describe a bond that trades without accrued interest, such as a zero-coupon bond or a bond that is in default."
    },
    {
       "key":404,
       "value":"floor broker",
       "description":"An individual member of an exchange who may execute orders on the floor."
    },
    {
       "key":405,
       "value":"floor trader",
       "description":"Members of the exchange who trade for their own accounts. Members of the NYSE may not trade from the floor for their own accounts."
    },
    {
       "key":406,
       "value":"flow of funds",
       "description":"A schedule of expenses and interested parties that prioritizes how payments will be made from the revenue generated by a facility financed by a municipal revenue bond."
    },
    {
       "key":407,
       "value":"forced conversion",
       "description":"The calling in of convertible bonds at a price that is less than the market value of the underlying common stock into which the bonds may be converted."
    },
    {
       "key":408,
       "value":"foreign currency",
       "description":"Currency of another country."
    },
    {
       "key":409,
       "value":"foreign currency option",
       "description":"An option to purchase or sell a specified amount of another country’s currency."
    },
    {
       "key":410,
       "value":"Form 10-K",
       "description":"An annual report filed by a corporation detailing its financial performance for the year. The annual report also contains the results of the final quarter."
    },
    {
       "key":411,
       "value":"Form 10-Q",
       "description":"A quarterly report filed by a corporation three times per year detailing its financial performance for the quarter."
    },
    {
       "key":412,
       "value":"form letter",
       "description":"A letter sent out by a brokerage firm or a registered representative to more than 25 people in a 90-day period. Form letters are subject to approval and recordkeeping requirements."
    },
    {
       "key":413,
       "value":"forward pricing",
       "description":"The way in which open-end mutual funds are valued for investors who wish to purchase or redeem shares of the fund. Mutual funds usually price their shares at the end of the business day. The price to be paid or received by the investor will be the price that is next calculated after the fund receives the order."
    },
    {
       "key":414,
       "value":"401K",
       "description":"A qualified retirement plan offered by an employer."
    },
    {
       "key":415,
       "value":"403B",
       "description":"A qualified retirement plan offered to teachers and employees of nonprofit organizations."
    },
    {
       "key":416,
       "value":"fourth market",
       "description":"A transaction between two large institutions without the use of a broker dealer."
    },
    {
       "key":417,
       "value":"fractional share",
       "description":"A portion of a whole share that represents ownership of an open-end mutual fund."
    },
    {
       "key":418,
       "value":"fraud",
       "description":"Any attempt to gain an unfair advantage over another party through the use of deception, concealment, or misrepresentation."
    },
    {
       "key":419,
       "value":"free credit balance",
       "description":"Cash reserves in a customer’s account that have not been invested. Customers must be notified of their free credit balances at least quarterly."
    },
    {
       "key":420,
       "value":"free look",
       "description":"A privilege offered to purchasers of contractual plans and insurance policies that will allow the individual to cancel the contract within the free-look period, usually 45 days."
    },
    {
       "key":421,
       "value":"freeriding",
       "description":"The purchase and sale of a security without depositing the money required to cover the purchase price as required by Regulation T."
    },
    {
       "key":422,
       "value":"freeriding and withholding",
       "description":"The withholding of new issue securities offered by a broker dealer for the benefit of the brokerage firm or an employee."
    },
    {
       "key":423,
       "value":"front-end load",
       "description":"(1) A sales charge paid by investors in open-end mutual funds that is paid at the time of purchase. (2) A contractual plan that seeks to assess sales charges in the first years of the plan and may charge up to 50% of the first year’s payments as sales charges."
    },
    {
       "key":424,
       "value":"frozen account",
       "description":"An account where the owner is required to deposit cash or securities up front, prior to any purchase or sale taking place. An account is usually frozen as a result of a customer’s failure to pay or deliver securities."
    },
    {
       "key":425,
       "value":"full power of attorney",
       "description":"A type of discretionary authority that allows a third party to purchase and sell securities as well as to withdraw cash and securities without the owner’s prior consent or knowledge. This type of authority is usually reserved to trustees and attorneys."
    },
    {
       "key":426,
       "value":"fully registered bonds",
       "description":"A type of bond issuance where the issuer has a complete record of the owners of the bonds and who is entitled to receive interest and principal payments. The owners of fully registered bonds are not required to clip coupons."
    },
    {
       "key":427,
       "value":"functional allocation",
       "description":"An arrangement for oil and gas programs where the general partner pays the tangible drilling costs and the limited partner absorbs the intangible drilling costs."
    },
    {
       "key":428,
       "value":"fundamental analyst",
       "description":"A method of valuing the company that takes into consideration the financial performance of the corporation, the value of its assets, and the quality of its management."
    },
    {
       "key":429,
       "value":"funded debt",
       "description":"Long-term debt obligations of corporations or municipalities."
    },
    {
       "key":430,
       "value":"fungible",
       "description":"Easily exchangeable items with the same conditions."
    },
    {
       "key":431,
       "value":"general account",
       "description":"An insurance company’s account that holds the money and investments for fixed contracts and traditional life insurance policies."
    },
    {
       "key":432,
       "value":"general obligation bond",
       "description":"A municipal bond that is backed by the taxing power of the state or municipality."
    },
    {
       "key":433,
       "value":"general partner",
       "description":"The partner in a general partnership who manages the business and is responsible for any debt of the program."
    },
    {
       "key":434,
       "value":"general securities principal",
       "description":"An individual who has passed the Series 24 exam and may supervise the activities of the firm and its agents."
    },
    {
       "key":435,
       "value":"generic advertising",
       "description":"Advertising designed to promote name recognition for a firm and securities as investments, but does not recommend specific securities."
    },
    {
       "key":436,
       "value":"good ’til cancel (GTC)",
       "description":"An order that remains on the books until it is executed or canceled."
    },
    {
       "key":437,
       "value":"goodwill",
       "description":"An intangible asset of a corporation, such as its name recognition and reputation, that adds to its value."
    },
    {
       "key":438,
       "value":"Government National Mortgage Association (GNMA; Ginnie Mae)",
       "description":"A government corporation that provides liquidity to the mortgage markets by purchasing pools of mortgages that have been insured by the Federal Housing Administration and the Veterans Administration. Ginnie Mae issues pass-through certificates to investors backed by the pools of mortgages."
    },
    {
       "key":439,
       "value":"government security",
       "description":"A security that is an obligation of the U.S. government and that is backed by the full faith and credit of the U.S. government, such as Treasury bills, notes, and bonds."
    },
    {
       "key":440,
       "value":"grant anticipation note (GAN)",
       "description":"Short-term municipal financing issued in anticipation of receiving a grant from the federal government or one of its agencies."
    },
    {
       "key":441,
       "value":"greenshoe option",
       "description":"An option given to an underwriter of common stock that will allow it to purchase up to an additional 15% of the offering from the issuer at the original offering price to cover over-allotments for securities that are in high demand."
    },
    {
       "key":442,
       "value":"gross domestic product (GDP)",
       "description":"The value of all goods and services produced by a country within a period of time. GDP includes government purchases, investments, and exports minus imports."
    },
    {
       "key":443,
       "value":"gross income",
       "description":"All income received by a taxpayer before deductions for taxes."
    },
    {
       "key":444,
       "value":"gross revenue pledge",
       "description":"A flow-of-funds pledge for a municipal revenue bond that states that debt service will be paid first."
    },
    {
       "key":445,
       "value":"growth fund",
       "description":"A fund whose objective is capital appreciation. Growth funds invest in common stocks to achieve their objective."
    },
    {
       "key":446,
       "value":"growth stock",
       "description":"The stock of a company whose earnings grow at a rate that is faster than the growth rate of the economy as a whole. Growth stocks are characterized by increased opportunities for appreciation and little or no dividends."
    },
    {
       "key":447,
       "value":"guardian",
       "description":"An individual who has a fiduciary responsibility for another, usually a minor."
    },
    {
       "key":448,
       "value":"halt",
       "description":"A temporary stop in the trading of a security. If a common stock is halted, all derivatives and convertibles will be halted as well."
    },
    {
       "key":449,
       "value":"head and shoulders",
       "description":"A chart pattern that indicates a reversal of a trend. A head-and-shoulders top indicates a reversal of an uptrend and is considered bearish. A head-and-shoulders bottom is the reversal of a downtrend and is considered bullish."
    },
    {
       "key":450,
       "value":"hedge",
       "description":"A position taken in a security to offset or reduce the risk associated with the risk of another security."
    },
    {
       "key":451,
       "value":"HH bond",
       "description":"A nonmarketable government security that pays semiannual interest. Series HH bonds are issued with a $500 minimum value and may only be purchased by trading matured Series EE bonds; they may not be purchased with cash."
    },
    {
       "key":452,
       "value":"high",
       "description":"The highest price paid for a security during a trading session or during a 52-week period."
    },
    {
       "key":453,
       "value":"holder",
       "description":"An individual or corporation that owns a security. The holder of a security is also known as being long the security."
    },
    {
       "key":454,
       "value":"holding period",
       "description":"The length of time during which an investor owns a security. The holding period is important for calculating tax liability."
    },
    {
       "key":455,
       "value":"hold in street name",
       "description":"The registration of customer securities in the name of the broker dealer. Most customers register securities in the name of the broker dealer to make the transfer of ownership easier."
    },
    {
       "key":456,
       "value":"horizontal spread",
       "description":"Also known as a calendar spread. The simultaneous purchase and sale of two calls or two puts on the same underlying security with the same exercise price but with different expiration months."
    },
    {
       "key":457,
       "value":"hot issue",
       "description":"A new issue of securities that trades at an immediate premium to its offering price in the secondary market."
    },
    {
       "key":458,
       "value":"HR 10 plan",
       "description":"See Keogh plan."
    },
    {
       "key":459,
       "value":"hypothecation",
       "description":"The customer’s pledge of securities as collateral for a margin loan."
    },
    {
       "key":460,
       "value":"immediate annuity",
       "description":"An annuity contract purchased with a single payment that entitles the holder to receive immediate payments from the contract. The annuitant purchases annuity units and usually begins receiving payments within 60 days."
    },
    {
       "key":461,
       "value":"immediate family",
       "description":"An individual’s immediate family includes parents, parents-in-law, children, spouse, and any relative financially dependent upon the individual."
    },
    {
       "key":462,
       "value":"immediate or cancel (IOC)",
       "description":"An order that is to be executed as fully as possible immediately and whatever is not executed will be canceled."
    },
    {
       "key":463,
       "value":"income bond",
       "description":"A highly speculative bond that is issued at a discount from par and only pays interest if the issuer has enough income to do so. The issuer of the income bond only promises to pay principal at maturity. Income bonds trade flat without accrued interest."
    },
    {
       "key":464,
       "value":"income fund",
       "description":"A mutual fund whose investment objective is to achieve current income for its shareholders by investing in bonds and preferred stocks."
    },
    {
       "key":465,
       "value":"income program",
       "description":"A type of oil and gas program that purchases producing wells to receive the income received from the sale of the proven reserves."
    },
    {
       "key":466,
       "value":"income statement",
       "description":"A financial statement that shows a corporation’s revenue and expenses for the time period in question."
    },
    {
       "key":467,
       "value":"indefeasible title",
       "description":"A record of ownership that cannot be challenged."
    },
    {
       "key":468,
       "value":"index",
       "description":"A representation of the price action of a given group of securities. Indexes are used to measure the condition of the market as a whole, such as with the S&P 500, or can be used to measure the condition of an industry group, such as with the Biotech index."
    },
    {
       "key":469,
       "value":"index option",
       "description":"An option on an underlying financial index. Index options settle in cash."
    },
    {
       "key":470,
       "value":"indication of interest",
       "description":"An investor’s expression of a willingness to purchase a new issue of securities after receiving a preliminary prospectus. The investor’s indication of interest is not binding on either the investor or the firm."
    },
    {
       "key":471,
       "value":"Individual Retirement Account (IRA)",
       "description":"A self-directed retirement account that allows individuals with earned income to contribute the lesser of 100% of earned income or the annual maximum per year. The contributions may be made with preor after-tax dollars, depending on the individual’s level of income and whether he or she is eligible to participate in an employer’s sponsored plan."
    },
    {
       "key":472,
       "value":"industrial development bond",
       "description":"A private-purpose municipal bond whose proceeds are used to build a facility that is leased to a corporation. The debt service on the bonds is supported by the lease payments."
    },
    {
       "key":473,
       "value":"inflation",
       "description":"The persistent upward pressure on the price of goods and services over time."
    },
    {
       "key":474,
       "value":"initial margin requirement",
       "description":"The initial amount of equity that a customer must deposit to establish a position. The initial margin requirement is set by the Federal Reserve Board under Regulation T."
    },
    {
       "key":475,
       "value":"initial public offering (IPO)",
       "description":"The first offering of common stock to the general investing public."
    },
    {
       "key":476,
       "value":"in part call",
       "description":"A partial call of a bond issue for redemption."
    },
    {
       "key":477,
       "value":"inside information",
       "description":"Information that is not known to people outside of the corporation. Information becomes public only after it is released by the corporation through a recognized media source. Inside information may be both material and immaterial. It is only illegal to trade on inside material information."
    },
    {
       "key":478,
       "value":"inside market",
       "description":"The highest bid and the lowest offer for a security."
    },
    {
       "key":479,
       "value":"insider",
       "description":"A company’s officers, directors, large stockholders of 10% or more of the company, and anyone who is in possession of nonpublic material information, along with the immediate family members of the same."
    },
    {
       "key":480,
       "value":"Insider Trading and Securities Fraud Enforcement Act of 1988",
       "description":"Federal legislation that made the penalties for people trading on material nonpublic information more severe. Penalties for insider traders are up to the greater of 300% of the amount of money made or the loss avoided or $1 million and up to 5 years in prison. People who disseminate inside information may be imprisoned and fined up to $1 million."
    },
    {
       "key":481,
       "value":"INSTINET",
       "description":"A computer network that facilitates trading of large blocks of stocks between institutions without the use of a broker dealer."
    },
    {
       "key":482,
       "value":"institutional account",
       "description":"An account in the name of an institution but operated for the benefit of others (i.e., banks and mutual funds). There is no minimum size for an institutional account."
    },
    {
       "key":483,
       "value":"institutional communication",
       "description":"Any communication that is distributed exclusively to institutional investors. Institutional communication does not require the preapproval of a principal but must be maintained for 3 years by the firm."
    },
    {
       "key":484,
       "value":"institutional investor",
       "description":"An investor who trades for its own account or for the accounts of others in large quantities and is covered by fewer protective laws."
    },
    {
       "key":485,
       "value":"insurance covenant",
       "description":"The promise of an issuer of revenue bonds to maintain insurance on the financed project."
    },
    {
       "key":486,
       "value":"intangible asset",
       "description":"Nonphysical property of a corporation, such as trademarks and copyrights."
    },
    {
       "key":487,
       "value":"intangible drilling cost (IDC)",
       "description":"Costs for an oil and gas program that are expensed in the year in which they are incurred for such things as wages, surveys, and well casings."
    },
    {
       "key":488,
       "value":"interbank market",
       "description":"An international currency market."
    },
    {
       "key":489,
       "value":"interest",
       "description":"The cost for borrowing money, usually charged at an annual percentage rate."
    },
    {
       "key":490,
       "value":"interest rate option",
       "description":"An option based on U.S. government securities. The options are either rate-based or priced-based options."
    },
    {
       "key":491,
       "value":"interest rate risk",
       "description":"The risk borne by investors in interest-bearing securities, which subjects the holder to a loss of principal should interest rates rise."
    },
    {
       "key":492,
       "value":"interlocking directorate",
       "description":"Corporate boards that share one or more directors."
    },
    {
       "key":493,
       "value":"Internal Revenue Code (IRC)",
       "description":"The codes that define tax liabilities for U.S. taxpayers."
    },
    {
       "key":494,
       "value":"interpositioning",
       "description":"The placing of another broker dealer in between the customer and the best market. Interpositioning is prohibited unless it can be demonstrated that the customer received a better price because of it."
    },
    {
       "key":495,
       "value":"interstate offering",
       "description":"A multistate offering of securities that requires that the issuer register with the SEC as well as with the states in which the securities will be sold."
    },
    {
       "key":496,
       "value":"in the money",
       "description":"A relationship between the strike price of an option and the underlying security’s price. A call is in the money when the strike price is lower than the security’s price. A put is in the money when the strike price is higher than the security’s price."
    },
    {
       "key":497,
       "value":"intrastate offering",
       "description":"See Rule 147."
    },
    {
       "key":498,
       "value":"intrinsic value",
       "description":"The amount by which an option is in the money."
    },
    {
       "key":499,
       "value":"introducing broker",
       "description":"See correspondent broker dealer."
    },
    {
       "key":500,
       "value":"inverted yield curve",
       "description":"A yield curve where the cost of short-term financing exceeds the cost of long-term financing."
    },
    {
       "key":501,
       "value":"investment adviser",
       "description":"Anyone who charges a fee for investment advice or who holds himself out to the public as being in the business of giving investment advice for a fee."
    },
    {
       "key":502,
       "value":"Investment Advisers Act of 1940",
       "description":"The federal legislation that sets forth guidelines for business requirements and activities of investment advisers."
    },
    {
       "key":503,
       "value":"investment banker",
       "description":"A financial institution that is in the business of raising capital for companies and municipalities by underwriting securities."
    },
    {
       "key":504,
       "value":"investment company",
       "description":"A company that sells undivided interests in a pool of securities and manages the portfolio for the benefit of the investors. Investment companies include management companies, unit investment trusts, and face-amount companies."
    },
    {
       "key":505,
       "value":"Investment Company Act of 1940",
       "description":"Federal legislation that regulates the operation and registration of investment companies."
    },
    {
       "key":506,
       "value":"investment-grade security",
       "description":"A security that has been assigned a rating in the highest rating tier by a recognized ratings agency."
    },
    {
       "key":507,
       "value":"investment objective",
       "description":"An investor’s set of goals as to how he or she is seeking to make money, such as capital appreciation or current income."
    },
    {
       "key":508,
       "value":"investor",
       "description":"The purchaser of a security who seeks to realize a profit."
    },
    {
       "key":509,
       "value":"IRA rollover",
       "description":"The temporary distribution of assets from an IRA and the subsequent reinvestment of the assets into another IRA within 60 days. An IRA may be rolled over only once per year and is subject to a 10% penalty and ordinary income taxes if the investor is under 59-1/2 and if the assets are not deposited in another qualified account within 60 days."
    },
    {
       "key":510,
       "value":"IRA transfer",
       "description":"The movement of assets from one qualified account to another without the account holder taking possession of the assets. Investors may transfer an IRA as often as they like."
    },
    {
       "key":511,
       "value":"issued stock",
       "description":"Stock that has actually been sold to the investing public."
    },
    {
       "key":512,
       "value":"issuer",
       "description":"Any entity that issues or proposes to issue securities."
    },
    {
       "key":513,
       "value":"joint account",
       "description":"An account that is owned by two or more parties. Joint accounts allow either party to enter transactions for the account. Both parties must sign a joint account agreement. All joint accounts must be designated as joint tenants in common or with rights of survivorship."
    },
    {
       "key":514,
       "value":"joint tenants in common (JTIC)",
       "description":"A joint account where the assets of a party who has died transfer to the decedent’s estate, not the other tenant."
    },
    {
       "key":515,
       "value":"joint tenants with rights of survivorship (JTWROS)",
       "description":"A joint account where the assets of a party who has died transfer to the surviving party, not the decedent’s estate."
    },
    {
       "key":516,
       "value":"joint venture",
       "description":"An interest in an operation shared by two or more parties. The parties have no other relationship beyond the joint venture."
    },
    {
       "key":517,
       "value":"junk bond",
       "description":"A bond with a high degree of default risk that has been assigned a speculative rating by the ratings agencies."
    },
    {
       "key":518,
       "value":"junk bond fund",
       "description":"A speculative bond fund that invests in high-yield bonds in order to achieve a high degree of current income."
    },
    {
       "key":519,
       "value":"Keogh plan",
       "description":"A qualified retirement account for self-employed individuals. Contributions are limited to the lesser of 20% of their gross income or the annual limit."
    },
    {
       "key":520,
       "value":"Keynesian economics",
       "description":"An economic theory that states that government intervention in the marketplace helps sustain economic growth."
    },
    {
       "key":521,
       "value":"know-your-customer rule",
       "description":"Industry regulation that requires a registered representative to be familiar with the customer’s financial objectives and needs prior to making a recommendation; also known as Rule 405."
    },
    {
       "key":522,
       "value":"lagging indicator",
       "description":"A measurement of economic activity that changes after a change has taken place in economic activity. Lagging indicators are useful confirmation tools when determining the strength of an economic trend. Lagging indicators include corporate profits, average duration of unemployment, and labor costs."
    },
    {
       "key":523,
       "value":"last in, first out (LIFO)",
       "description":"An accounting method used that states that the last item that was produced is the first item sold."
    },
    {
       "key":524,
       "value":"leading indicator",
       "description":"A measurement of economic activity that changes prior to a change in economic activity. Leading economic indicators are useful in predicting a coming trend in economic activity. Leading economic indicators include housing permits, new orders for durable goods, and the S&P 500."
    },
    {
       "key":525,
       "value":"LEAPS (long-term equity anticipation securities)",
       "description":"A long-term option on a security that has an expiration of up to 39 months."
    },
    {
       "key":526,
       "value":"lease rental bonds",
       "description":"A municipal bond that is issued to finance the building of a facility that will be rented out. The lease payments on the facility will support the bond’s debt service."
    },
    {
       "key":527,
       "value":"legal list",
       "description":"A list of securities that have been approved by certain state securities regulators for purchase by fiduciaries."
    },
    {
       "key":528,
       "value":"legal opinion",
       "description":"An opinion issued by a bond attorney stating that the issue is a legally binding obligation of the state or municipality. The legal opinion also contains a statement regarding the tax status of the interest payments received by investors."
    },
    {
       "key":529,
       "value":"legislative risk",
       "description":"The risk that the government may do something that adversely affects an investment."
    },
    {
       "key":530,
       "value":"letter of intent (LOI)",
       "description":"A letter signed by the purchaser of mutual fund shares that states the investor’s intention to invest a certain amount of money over a 13-month period. By agreeing to invest this sum, the investor is entitled to receive a lower sales charge on all purchases covered by the letter of intent. The letter of intent may be backdated up to 90 days from an initial purchase. Should the investor fail to invest the stated sum, a sales charge adjustment will be charged."
    },
    {
       "key":531,
       "value":"level load",
       "description":"A mutual fund share that charges a flat annual fee, such as a 12B-1 fee."
    },
    {
       "key":532,
       "value":"level one",
       "description":"A Nasdaq workstation service that allows the agent to see the inside market only."
    },
    {
       "key":533,
       "value":"level two",
       "description":"A Nasdaq workstation service that allows the order-entry firm to see the inside market, to view the quotes entered by all market makers, and to execute orders."
    },
    {
       "key":534,
       "value":"level three",
       "description":"A Nasdaq workstation service that allows market-making firms to see the inside market, to view the quotes entered by all market makers, to execute orders, and to enter their own quotes for the security. This is the highest level of Nasdaq service."
    },
    {
       "key":535,
       "value":"leverage",
       "description":"The use of borrowed funds to try to obtain a rate of return that exceeds the cost of the funds."
    },
    {
       "key":536,
       "value":"liability",
       "description":"A legal obligation to pay a debt either incurred through borrowing or through the normal course of business."
    },
    {
       "key":537,
       "value":"life annuity/straight life",
       "description":"An annuity payout option that provides payments over the life of the annuitant."
    },
    {
       "key":538,
       "value":"life annuity with period certain",
       "description":"An annuity payout option that provides payments to the annuitant for life or to the annuitant’s estate for the period certain, whichever is longer."
    },
    {
       "key":539,
       "value":"life contingency",
       "description":"An annuity payout option that provides a death benefit in case the annuitant dies during the accumulation stage."
    },
    {
       "key":540,
       "value":"limit order",
       "description":"An order that sets a maximum price that the investor will pay in the case of a buy order or the minimum price the investor will accept in the case of a sell order."
    },
    {
       "key":541,
       "value":"limited liability",
       "description":"A protection afforded to investors in securities that limits their liability to the amount of money invested in the securities."
    },
    {
       "key":542,
       "value":"limited partner",
       "description":"A passive investor in a direct participation program who has no role in the project’s management."
    },
    {
       "key":543,
       "value":"limited partnership (LP)",
       "description":"An association of two or more partners with at least one partner being the general partner who is responsible for the management of the partnership."
    },
    {
       "key":544,
       "value":"limited partnership agreement",
       "description":"The foundation of all limited partnerships. The agreement is the contract between all partners, and it spells out the authority of the general partner and the rights of all limited partners."
    },
    {
       "key":545,
       "value":"limited power of attorney/limited trading authorization",
       "description":"Legal authorization for a representative or a firm to affect purchases and sales for a customer’s account without the customer’s prior knowledge. The authorization is limited to buying and selling securities and may not be given to another party."
    },
    {
       "key":546,
       "value":"limited principal",
       "description":"An individual who has passed the Series 26 exam and may supervise Series 6 limited representatives."
    },
    {
       "key":547,
       "value":"limited representative",
       "description":"An individual who has passed the Series 6 exam and may represent a broker dealer in the sale of mutual fund shares and variable contracts."
    },
    {
       "key":548,
       "value":"limited tax bond",
       "description":"A type of general obligation bond that is issued by a municipality that may not increase its tax rate to pay the debt service of the issue."
    },
    {
       "key":549,
       "value":"liquidity",
       "description":"The ability of an investment to be readily converted into cash."
    },
    {
       "key":550,
       "value":"liquidity risk",
       "description":"The risk that an investor may not be able to sell a security when needed or that selling a security when needed will adversely affect the price."
    },
    {
       "key":551,
       "value":"listed option",
       "description":"A standardized option contract that is traded on an exchange."
    },
    {
       "key":552,
       "value":"listed security",
       "description":"A security that trades on one of the exchanges. Only securities that trade on an exchange are known as listed securities."
    },
    {
       "key":553,
       "value":"loan consent agreement",
       "description":"A portion of the margin agreement that allows the broker dealer to loan out the customer’s securities to another customer who wishes to borrow them to sell the security short."
    },
    {
       "key":554,
       "value":"locked market",
       "description":"A market condition that results when the bid and the offer for a security are equal."
    },
    {
       "key":555,
       "value":"LOI",
       "description":"See letter of intent."
    },
    {
       "key":556,
       "value":"London Interbank Offered Rate (LIBOR)",
       "description":"The interbank rates for dollar-denominated deposits in England."
    },
    {
       "key":557,
       "value":"long",
       "description":"A term used to describe an investor who owns a security."
    },
    {
       "key":558,
       "value":"long market value",
       "description":"The total long market value of a customer’s account."
    },
    {
       "key":559,
       "value":"long-term gain",
       "description":"A profit realized through the sale of a security at a price that is higher than its purchase price after being held for more than 12 months."
    },
    {
       "key":560,
       "value":"long-term loss",
       "description":"A loss realized through the sale of a security at a price that is lower than its purchase price after being held for more than 12 months."
    },
    {
       "key":561,
       "value":"loss carry forward",
       "description":"A capital loss realized on the sale of an asset in 1 year that is carried forward in whole or part to subsequent tax years."
    },
    {
       "key":562,
       "value":"low",
       "description":"The lowest price at which a security has traded in any given period, usually measured during a trading day or for 52 weeks."
    },
    {
       "key":563,
       "value":"M1",
       "description":"The most liquid measure of the money supply. It includes all currency and demand and NOW deposits (checking accounts)."
    },
    {
       "key":564,
       "value":"M2",
       "description":"A measure of the money supply that includes M1 plus all time deposits, savings accounts, and noninstitutional money market accounts."
    },
    {
       "key":565,
       "value":"M3",
       "description":"A measure of the money supply that includes M2 and large time deposits, institutional money market funds, short-term repurchase agreements, and other large liquid assets."
    },
    {
       "key":566,
       "value":"maintenance call",
       "description":"A demand for additional cash or collateral made by a broker dealer when a margin customer’s account equity has fallen below the minimum requirement of the NYSE or that is set by the broker dealer."
    },
    {
       "key":567,
       "value":"maintenance covenant",
       "description":"A promise made by an issuer of a municipal revenue bond to maintain the facility in good repair."
    },
    {
       "key":568,
       "value":"Major Market Index (XMI)",
       "description":"An index created by the Amex to AMEX 15 of the 30 largest stocks in the Dow Jones Industrial Average."
    },
    {
       "key":569,
       "value":"Maloney Act of 1938",
       "description":"An amendment to the Securities Exchange Act of 1934 that gave the NASD (now part of FINRA) the authority to regulate the over-the-counter market."
    },
    {
       "key":570,
       "value":"managed underwriting",
       "description":"An underwriting conducted by a syndicate led by the managing underwriter."
    },
    {
       "key":571,
       "value":"management company",
       "description":"A type of investment company that actively manages a portfolio of securities in order to meet a stated investment objective. Management companies are also known as mutual funds."
    },
    {
       "key":572,
       "value":"management fee",
       "description":"(1) The fee received by the lead or managing underwriter of a syndicate. (2) The fee received by a sponsor of a direct participation program."
    },
    {
       "key":573,
       "value":"managing partner",
       "description":"The general partner in a direct participation program."
    },
    {
       "key":574,
       "value":"managing underwriter",
       "description":"The lead underwriter in a syndicate who is responsible for negotiating with the issuer, forming the syndicate, and settling the syndicate account."
    },
    {
       "key":575,
       "value":"margin",
       "description":"The amount of customer equity that is required to hold a position in a security."
    },
    {
       "key":576,
       "value":"margin account",
       "description":"An account that allows the customer to borrow money from the brokerage firm to buy securities."
    },
    {
       "key":577,
       "value":"margin call",
       "description":"A demand for cash or collateral mandated by the Federal Reserve Board under Regulation T."
    },
    {
       "key":578,
       "value":"margin department",
       "description":"The department in a broker dealer that calculates money owed by the customer or money due the customer."
    },
    {
       "key":579,
       "value":"margin maintenance call",
       "description":"See maintenance call."
    },
    {
       "key":580,
       "value":"mark to the market",
       "description":"The monitoring of the current value of a position relative to the price at which the trade was executed for securities purchased on margin or on a when-issued basis."
    },
    {
       "key":581,
       "value":"markdown",
       "description":"The profit earned by a dealer on a transaction when purchasing securities for its own account from a customer."
    },
    {
       "key":582,
       "value":"marketability",
       "description":"The ability of an investment to be exchanged between two investors. A security with an active secondary market has a higher level of marketability than one whose market is not as active."
    },
    {
       "key":583,
       "value":"market arbitrage",
       "description":"A type of arbitrage that consists of purchasing a security in one marketplace and selling it in another to take advantage of price inefficiencies."
    },
    {
       "key":584,
       "value":"market letter",
       "description":"A regular publication, usually issued by an investment adviser, that offers information and/or advice regarding securities, market conditions, or the economy as a whole."
    },
    {
       "key":585,
       "value":"market maker",
       "description":"A Nasdaq firm that is required to quote a continuous two-sided market for the securities in which it trades."
    },
    {
       "key":586,
       "value":"market not held",
       "description":"A type of order that gives the floor broker discretion over the time and price of execution."
    },
    {
       "key":587,
       "value":"market on close",
       "description":"An order that will be executed at whatever price the market is at, either on the closing print or just prior to the closing print."
    },
    {
       "key":588,
       "value":"market on open",
       "description":"An order that will be executed at whatever price the market is at, either on the opening print or just after the opening print."
    },
    {
       "key":589,
       "value":"market order",
       "description":"A type of order that will be executed immediately at the best available price once it is presented to the market."
    },
    {
       "key":590,
       "value":"market-out clause",
       "description":"A clause in an underwriting agreement that gives the syndicate the ability to cancel the underwriting if it finds a material problem with the information or condition of the issuer."
    },
    {
       "key":591,
       "value":"market risk/ systematic risk",
       "description":"The risk inherent in any investment in the market that states an investor may lose money simply because the market is going down."
    },
    {
       "key":592,
       "value":"market value",
       "description":"The value of a security that is determined in the marketplace by the investors who enter bids and offers for a security."
    },
    {
       "key":593,
       "value":"markup",
       "description":"The compensation paid to a securities dealer for selling a security to a customer from its inventory."
    },
    {
       "key":594,
       "value":"markup policy",
       "description":"FINRA’s guideline that states that the price that is paid or received by an investor must be reasonably related to the market price for that security. FINRA offers 5% as a guideline for what is reasonable to charge investors when they purchase or sell securities."
    },
    {
       "key":595,
       "value":"material information",
       "description":"Information that would affect a company’s current or future prospects or an investor’s decision to invest in the company."
    },
    {
       "key":596,
       "value":"maturity date",
       "description":"The date on which a bond’s principal amount becomes payable to its holders."
    },
    {
       "key":597,
       "value":"member",
       "description":"A member of FINRA or one of the 1,366 members of the NYSE."
    },
    {
       "key":598,
       "value":"member firm",
       "description":"A firm that is a member of the NYSE, FINRA, or another self-regulatory organization."
    },
    {
       "key":599,
       "value":"member order",
       "description":"A retail order entered by a member of a municipal bond syndicate for which the member will receive all of the sales credit."
    },
    {
       "key":600,
       "value":"mini maxi underwriting",
       "description":"A type of best efforts underwriting that states that the offering will not become effective until a minimum amount is sold and sets a maximum amount that may be sold."
    },
    {
       "key":601,
       "value":"minimum death benefit",
       "description":"The minimum guaranteed death benefit that will be paid to the beneficiaries if the holder of a variable life insurance policy dies."
    },
    {
       "key":602,
       "value":"minus tick",
       "description":"A trade in an exchange-listed security that is at a price that is lower than the previous trade."
    },
    {
       "key":603,
       "value":"modern portfolio theory",
       "description":"An investing approach that looks at the overall return and risk of a portfolio as a whole, not as a collection of single investments."
    },
    {
       "key":604,
       "value":"modified accelerated cost recovery system (MACRS)",
       "description":"An accounting method that allows the owner to recover a larger portion of the asset’s value in the early years of its life."
    },
    {
       "key":605,
       "value":"monetarist theory",
       "description":"A theory that states that the money supply is the driving force in the economy and that a well-managed money supply will benefit the economy."
    },
    {
       "key":606,
       "value":"monetary policy",
       "description":"Economic policy that is controlled by the Federal Reserve Board and controls the amount of money in circulation and the level of interest rates."
    },
    {
       "key":607,
       "value":"money market",
       "description":"The secondary market where short-term highly liquid securities are traded. Securities traded in the money market include T-bills, negotiable CDs, bankers’ acceptances, commercial paper, and other short-term securities with less than 12 months to maturity."
    },
    {
       "key":608,
       "value":"money market mutual fund",
       "description":"A mutual fund that invests in money market instruments to generate monthly interest for its shareholders. Money market mutual funds have a stable NAV that is equal to $1, but it is not guaranteed."
    },
    {
       "key":609,
       "value":"money supply",
       "description":"The total amount of currency, loans, and credit in the economy. The money supply is measured by M1, M2, M3, and L."
    },
    {
       "key":610,
       "value":"moral obligation bond",
       "description":"A type of municipal revenue bond that will allow the state or municipality to vote to cover a shortfall in the debt service."
    },
    {
       "key":611,
       "value":"multiplier effect",
       "description":"The ability of the money supply to grow simply through the normal course of banking. When banks and other financial institutions accept deposits and subsequently loan out those deposits to earn interest, the amount of money in the system grows."
    },
    {
       "key":612,
       "value":"municipal bond",
       "description":"A bond issued by a state or political subdivision of a state in an effort to finance its operations. Interest earned by investors in municipal bonds is almost always free from federal income taxes."
    },
    {
       "key":613,
       "value":"municipal bond fund",
       "description":"A mutual fund that invests in a portfolio of municipal debt in an effort to produce income that is free from federal income taxes for its investors."
    },
    {
       "key":614,
       "value":"Municipal Bond Investors Assurance Corp. (MBIA)",
       "description":"An independent insurance company that will, for a fee received from the issuer, insure the interest and principal payments on a municipal bond."
    },
    {
       "key":615,
       "value":"municipal note",
       "description":"A short-term municipal issue sold to manage the issuer’s cash flow, usually in anticipation of the offering of long-term financing."
    },
    {
       "key":616,
       "value":"Municipal Securities Rulemaking Board (MSRB)",
       "description":"The self-regulatory organization that oversees the issuance and trading of municipal bonds. The MSRB’s rules are enforced by other industry SROs."
    },
    {
       "key":617,
       "value":"Munifacts",
       "description":"A service that provides real-time secondary market quotes. Munifacts is now known as Thomson Muni Market Monitor."
    },
    {
       "key":618,
       "value":"mutual fund",
       "description":"An investment company that invests in and manages a portfolio of securities for its shareholders. Open-end mutual funds sell their shares to investors on a continuous basis and must stand ready to redeem their shares upon the shareholder’s request."
    },
    {
       "key":619,
       "value":"mutual fund custodian",
       "description":"A qualified financial institution that maintains physical custody of a mutual fund’s cash and securities. Custodians are usually banks, trust companies, or exchange member firms."
    },
    {
       "key":620,
       "value":"naked",
       "description":"The sale of a call option without owning the underlying security or the sale of a put option without being short the stock or having cash on deposit that is sufficient to purchase the underlying security."
    },
    {
       "key":621,
       "value":"narrow-based index",
       "description":"An index that is based on a market sector or a limited number of securities."
    },
    {
       "key":622,
       "value":"NASD (National Association of Securities Dealers)",
       "description":"The industry self-regulatory agency that was authorized by the Maloney Act of 1938 and empowered to regulate the over-the-counter market. The NASD is now part of FINRA."
    },
    {
       "key":623,
       "value":"NASD bylaws",
       "description":"The rules that define the operation of the NASD and how it regulates the over-thecounter market. The four major bylaws are the Rules of Fair Practice, the Uniform Practice Code, the Code of Procedure, and the Code of Arbitration. Now known as FINRA bylaws."
    },
    {
       "key":624,
       "value":"NASD Manual",
       "description":"An NASD publication that outlines the rules and regulations of NASD membership. Now known as the FINRA Manual."
    },
    {
       "key":625,
       "value":"National Securities Clearing Corporation (NSCC)",
       "description":"The clearing intermediary through which clearing member firms reconcile their securities accounts."
    },
    {
       "key":626,
       "value":"NAV (net asset value)",
       "description":"The net value of a mutual fund after deducting all its liabilities. A mutual fund must calculate its NAV at least once per business day. To determine NAV per share, simply divide the mutual fund’s NAV by the total number of shares outstanding."
    },
    {
       "key":627,
       "value":"negotiability",
       "description":"The ability of an investment to be freely exchanged between non interested parties."
    },
    {
       "key":628,
       "value":"negotiable certificate of deposit",
       "description":"A certificate issued by a bank for a time deposit in excess of $100,000 that can be exchanged between parties prior to its maturity date. FDIC insurance only covers the first $250,000 of the principal amount should the bank fail."
    },
    {
       "key":629,
       "value":"NOW (negotiable order of withdrawal) Account",
       "description":"A type of demand deposit that allows the holder to write checks against an interestbearing account."
    },
    {
       "key":630,
       "value":"net change",
       "description":"The difference between the previous day’s closing price and the price of the most recently reported trade for a security."
    },
    {
       "key":631,
       "value":"net current assets per share",
       "description":"A calculation of the value per share that excludes fixed assets and intangibles."
    },
    {
       "key":632,
       "value":"net debt per capita",
       "description":"A measure of a municipal issuer’s ability to meet its obligations. It measures the debt level of the issuer in relation to the population."
    },
    {
       "key":633,
       "value":"net debt to assessed valuation",
       "description":"A measure of the issuer’s ability to meet its obligations and to raise additional revenue through property taxes."
    },
    {
       "key":634,
       "value":"net direct debt",
       "description":"The total amount of general obligation debt, including notes and short-term financing, issued by a municipality or state."
    },
    {
       "key":635,
       "value":"net interest cost (NIC)",
       "description":"A calculation that measures the interest cost of a municipal issue over the life of all bonds. Most competitive underwritings for municipal securities are awarded to the syndicate that submits the bid with the lowest NIC."
    },
    {
       "key":636,
       "value":"net investment income",
       "description":"The total sum of investment income derived from dividend and interest income after subtracting expenses."
    },
    {
       "key":637,
       "value":"net revenue pledge",
       "description":"A pledge from a revenue bond that pays maintenance and operation expenses first, then debt service."
    },
    {
       "key":638,
       "value":"net total debt",
       "description":"The total of a municipality’s direct debt plus its overlapping debt."
    },
    {
       "key":639,
       "value":"net worth",
       "description":"The value of a corporation after subtracting all of its liabilities. A corporation’s net worth is also equal to shareholder’s equity."
    },
    {
       "key":640,
       "value":"new account form",
       "description":"Paperwork that must be filled out and signed by the representative and a principal of the firm prior to the opening of any account being opened for a customer."
    },
    {
       "key":641,
       "value":"new construction program",
       "description":"A real estate program that seeks to achieve capital appreciation by building new properties."
    },
    {
       "key":642,
       "value":"new housing authority (NHA)",
       "description":"A municipal bond issued to build low-income housing. NHA bonds are guaranteed by the U.S. government and are considered the safest type of municipal bonds. NHA bonds are not considered to be double-barreled bonds."
    },
    {
       "key":643,
       "value":"new issue",
       "description":"See initial public offering (IPO)."
    },
    {
       "key":644,
       "value":"New York Stock Exchange (NYSE)",
       "description":"A membership organization that provides a marketplace for securities to be exchanged in one centralized location through a dual-auction process."
    },
    {
       "key":645,
       "value":"no-load fund",
       "description":"A fund that does not charge the investor a sales charge to invest in the fund. Shares of no-load mutual funds are sold directly from the fund company to the investor."
    },
    {
       "key":646,
       "value":"nominal owner",
       "description":"An individual or entity registered as the owner of record of securities for the benefit of another party."
    },
    {
       "key":647,
       "value":"nominal quote",
       "description":"A quote given for informational purposes only. A trader who identifies a quote as being nominal cannot be held to trading at the prices that were clearly identified as being nominal."
    },
    {
       "key":648,
       "value":"nominal yield",
       "description":"The yield that is stated or named on the security. The nominal yield, once it has been set, never changes, regardless of the market price of the security."
    },
    {
       "key":649,
       "value":"noncompetitive bid",
       "description":"A bid submitted for Treasury bills where the purchaser agrees to accept the average of all yields accepted at the auction. Noncompetitive tenders are always the first orders filled at the auction."
    },
    {
       "key":650,
       "value":"noncumulative preferred",
       "description":"A type of preferred stock whose dividends do not accumulate in arrears if the issuer misses the payment."
    },
    {
       "key":651,
       "value":"nondiscrimination",
       "description":"A clause that states that all eligible individuals must be allowed to participate in a qualified retirement plan."
    },
    {
       "key":652,
       "value":"nondiversification",
       "description":"An investment strategy that concentrates its investments among a small group of securities or issuers."
    },
    {
       "key":653,
       "value":"nondiversified management company",
       "description":"An investment company that concentrates its investments among a few issuers or securities and does not meet the diversification requirements of the Investment Company Act of 1940."
    },
    {
       "key":654,
       "value":"nonfixed UIT",
       "description":"A type of UIT that allows changes in the portfolio and traditionally invests in mutual fund shares."
    },
    {
       "key":655,
       "value":"nonqualified retirement plan",
       "description":"A retirement plan that does not allow contributions to be made with pre-tax dollars; that is, the retirement plan does not qualify for beneficial tax treatment from the IRS for its contributions."
    },
    {
       "key":656,
       "value":"nonsystematic risk",
       "description":"A risk that is specific to an issuer or an industry."
    },
    {
       "key":657,
       "value":"note",
       "description":"An intermediateterm interest-bearing security that represents an obligation of its issuer."
    },
    {
       "key":658,
       "value":"not-held (NH) order",
       "description":"An order that gives the floor broker discretion as to the time and price of execution."
    },
    {
       "key":659,
       "value":"numbered account",
       "description":"An account that has been designated a number for identification purposes in order to maintain anonymity for its owner. The owner must sign a statement acknowledging ownership."
    },
    {
       "key":660,
       "value":"odd lot",
       "description":"A transaction that is for less than 100 shares of stock or for less than 5 bonds."
    },
    {
       "key":661,
       "value":"odd lot differential",
       "description":"An additional fee that may be charged to an investor for the handling of odd lot transactions (usually waived)."
    },
    {
       "key":662,
       "value":"odd lot theory",
       "description":"A contrarian theory that states that small investors will invariably buy and sell at the wrong time."
    },
    {
       "key":663,
       "value":"offer",
       "description":"A price published at which an investor or broker dealer is willing to sell a security."
    },
    {
       "key":664,
       "value":"offering circular",
       "description":"The offering document that is prepared by a corporation selling securities under a Regulation A offering."
    },
    {
       "key":665,
       "value":"office of supervisory jurisdiction (OSJ)",
       "description":"An office identified by the broker dealer as having supervisory responsibilities for agents. It has final approval of new accounts, makes markets, and structures offerings."
    },
    {
       "key":666,
       "value":"Office of the Comptroller of the Currency",
       "description":"An office of the U.S. Treasury that is responsible for regulating the practices of national banks."
    },
    {
       "key":667,
       "value":"official notice of sale",
       "description":"The notice of sale published in the Daily Bond Buyer by a municipal issuer that is used to obtain an underwriter for municipal bonds."
    },
    {
       "key":668,
       "value":"official statement",
       "description":"The offering document for a municipal issuer that must be provided to every purchaser if the issuer prepares one."
    },
    {
       "key":669,
       "value":"oil and gas direct participation program",
       "description":"A type of direct participation program designed to invest in oil and gas production or exploration."
    },
    {
       "key":670,
       "value":"oil depletion allowance",
       "description":"An accounting method used to reduce the amount of reserves available from a producing well."
    },
    {
       "key":671,
       "value":"omnibus account",
       "description":"An account used by an introducing member to execute and clear all of its customers’ trades."
    },
    {
       "key":672,
       "value":"open-end covenant",
       "description":"A type of bond indenture that allows for the issuance of additional bonds with the same claim on the collateral as the original issue."
    },
    {
       "key":673,
       "value":"open-end investment company",
       "description":"See mutual fund."
    },
    {
       "key":674,
       "value":"option",
       "description":"A contract between two investors to purchase or sell a security at a given price for a certain period of time."
    },
    {
       "key":675,
       "value":"option agreement",
       "description":"A form that must be signed and returned by an option investor within 15 days of the account’s approval to trade options."
    },
    {
       "key":676,
       "value":"option disclosure document",
       "description":"A document that must be furnished to all option investors at the time the account is approved for options trading. It is published by the Options Clearing Corporation (OCC), and it details the risks and features of standardized options."
    },
    {
       "key":677,
       "value":"Options Clearing Corporation (OCC)",
       "description":"The organization that issues and guarantees the performance of standardized options."
    },
    {
       "key":678,
       "value":"order book official (OBO)",
       "description":"Employees of the CBOE who are responsible for maintaining a fair and orderly market in the options assigned to them and for executing orders that have been left with them."
    },
    {
       "key":679,
       "value":"order department",
       "description":"The department of a broker dealer that is responsible for routing orders to the markets for execution."
    },
    {
       "key":680,
       "value":"order memorandum/ order ticket",
       "description":"The written document filled out by a registered representative that identifies, among other things, the security, the amount, the customer, and the account number for which the order is being entered."
    },
    {
       "key":681,
       "value":"original issue discount (OID)",
       "description":"A bond that has been issued to the public at a discount to its par value. The OID on a corporate bond is taxed as if it was earned annually. The OID on a municipal bond is exempt from taxation."
    },
    {
       "key":682,
       "value":"OTC market",
       "description":"See over-the-counter (OTC) market."
    },
    {
       "key":683,
       "value":"out of the money",
       "description":"The relationship of an option’s strike price to the underlying security’s price when exercising the option would not make economic sense. A call is out of the money when the security’s price is below the option’s strike price. A put is out of the money when the security’s price is above the option’s strike price."
    },
    {
       "key":684,
       "value":"outstanding stock",
       "description":"The total amount of a security that has been sold to the investing public and that remains in the hands of the investing public."
    },
    {
       "key":685,
       "value":"overlapping debt",
       "description":"The portion of another taxing authority’s debt that a municipality is responsible for."
    },
    {
       "key":686,
       "value":"overriding royalty interest",
       "description":"A type of sharing arrangement that offers an individual with no risk a portion of the revenue in exchange for something of value, such as the right to drill on the owner’s land."
    },
    {
       "key":687,
       "value":"over-the-counter (OTC) market",
       "description":"An interdealer market that consists of a computer and phone network through which broker dealers trade securities."
    },
    {
       "key":688,
       "value":"par",
       "description":"The stated principal amount of a security. Par value is of great importance for fixed-income securities such as bonds or preferred stock. Par value for bonds is traditionally $1,000, whereas par for a preferred stock is normally $100. Par value is of little importance when looking at common stock."
    },
    {
       "key":689,
       "value":"parity",
       "description":"A condition that results when the value of an underlying common stock to be received upon conversion equals the value of the convertible security."
    },
    {
       "key":690,
       "value":"partial call",
       "description":"A call of a portion of an issuer’s callable securities."
    },
    {
       "key":691,
       "value":"participation",
       "description":"The code set forth in the Employee Retirement Income Security Act of 1974 that states who is eligible to participate in an employer sponsored retirement plan."
    },
    {
       "key":692,
       "value":"passive income",
       "description":"Income received by an individual for which no work was performed, such as rental income received from a rental property."
    },
    {
       "key":693,
       "value":"passive loss",
       "description":"A loss realized on an investment in a limited partnership or rental property that can be used to offset passive income."
    },
    {
       "key":694,
       "value":"pass-through certificate",
       "description":"A security that passes through income and principal payments made to an underlying portfolio of mortgages. Ginnie Mae is one of the biggest issuers of this type of security."
    },
    {
       "key":695,
       "value":"payment date",
       "description":"The day when a dividend will actually be sent to investors. The payment date is set by the corporation’s board of directors at the time when they initially declare the dividend."
    },
    {
       "key":696,
       "value":"payout stage",
       "description":"The period during which an annuitant receives payments from an annuity contract."
    },
    {
       "key":697,
       "value":"payroll deduction plan",
       "description":"A nonqualified retirement plan where employees authorize the employer to take regular deductions from their paychecks to invest in a retirement account."
    },
    {
       "key":698,
       "value":"pension plan",
       "description":"A contractual retirement plan between an employee and an employer that is designed to provide regular income for the employee after retirement."
    },
    {
       "key":699,
       "value":"percentage depletion",
       "description":"An accounting method that allows for a tax deduction for the reduction of reserves."
    },
    {
       "key":700,
       "value":"periodic payment plan",
       "description":"A contract to purchase mutual fund shares over an extended period of time, usually in exchange for the fund company waiving its minimum investment requirement."
    },
    {
       "key":701,
       "value":"person",
       "description":"Any individual or entity that can enter into a legally binding contract for the purchase and sale of securities."
    },
    {
       "key":702,
       "value":"personal income",
       "description":"Income earned by an individual from providing services and through investments."
    },
    {
       "key":703,
       "value":"phantom income",
       "description":"(1) A term used to describe the taxable appreciation on a zero-coupon bond. (2) The term used to describe taxable income generated by a limited partnership that is not producing positive cash flow."
    },
    {
       "key":704,
       "value":"PINK OTC",
       "description":"An electronic quote service containing quotes for unlisted securities that is published by the OTC Markets Group."
    },
    {
       "key":705,
       "value":"placement ratio",
       "description":"A ratio that details the percentage of municipal bonds sold, relative to the number of bonds offered in the last week, published by the Daily Bond Buyer."
    },
    {
       "key":706,
       "value":"plus tick",
       "description":"A transaction in an exchange-listed security that is higher than the previous transaction."
    },
    {
       "key":707,
       "value":"point",
       "description":"An increment of change in the price of a security: 1 bond point equals 1% of par or 1% of $1,000, or $10."
    },
    {
       "key":708,
       "value":"POP",
       "description":"See public offering price (POP)."
    },
    {
       "key":709,
       "value":"portfolio income",
       "description":"Interest and dividends earned through investing in securities."
    },
    {
       "key":710,
       "value":"portfolio manager",
       "description":"An entity that is hired to manage the investment portfolios of a mutual fund. The portfolio manager is paid a fee that is based on the net assets of the fund."
    },
    {
       "key":711,
       "value":"position",
       "description":"The amount of a security in which an investor has an interest by either being long (owning) or short (owing) the security."
    },
    {
       "key":712,
       "value":"power of substitution",
       "description":"See stock power."
    },
    {
       "key":713,
       "value":"preemptive right",
       "description":"The right of a common stockholder to maintain proportional ownership interest in a security. A corporation may not issue additional shares of common stock without first offering those shares to existing stockholders."
    },
    {
       "key":714,
       "value":"preferred stock",
       "description":"An equity security issued with a stated dividend rate. Preferred stockholders have a higher claim on a corporation’s dividends and assets than common holders."
    },
    {
       "key":715,
       "value":"preferred stock ratio",
       "description":"A ratio detailing the amount of an issuer’s total capitalization that is made up of preferred stock. The ratio is found by dividing the total par value of preferred stock by the issuer’s total capitalization."
    },
    {
       "key":716,
       "value":"preliminary prospectus/red herring",
       "description":"A document used to solicit indications of interest during the cooling-off period for a new issue of securities. All of the information in the preliminary prospectus is subject to revision and change. The cover of a preliminary prospectus must have a statement saying that the securities have not yet become registered and that they may not be sold until the registration becomes effective. This statement is written in red ink, and this is where the term red herring comes from."
    },
    {
       "key":717,
       "value":"price-earnings ratio (PE)",
       "description":"A measure of value used by analysts. It is calculated by dividing the issuer’s stock price by its earnings per share."
    },
    {
       "key":718,
       "value":"price spread",
       "description":"A term used to describe an option spread where the long and short options differ only in their exercise prices."
    },
    {
       "key":719,
       "value":"primary earnings per share",
       "description":"The amount of earnings available per common share prior to the conversion of any outstanding convertible securities."
    },
    {
       "key":720,
       "value":"prime rate",
       "description":"The interest rate that banks charge their best corporate customers on loans."
    },
    {
       "key":721,
       "value":"principal",
       "description":"(1) The face amount of a bond. (2) A broker dealer trading for its own account. (3) An individual who has successfully completed a principal exam and may supervise representatives."
    },
    {
       "key":722,
       "value":"principal transaction",
       "description":"A transaction where a broker dealer participates in a trade by buying or selling securities for its own account."
    },
    {
       "key":723,
       "value":"priority",
       "description":"The acceptance of bids and offers for exchange-listed securities on a first-come, first-served (FCFS) basis."
    },
    {
       "key":724,
       "value":"private placement",
       "description":"The private sale of securities to a limited number of investors. Also known as a Regulation D offering."
    },
    {
       "key":725,
       "value":"profit sharing plan",
       "description":"A plan that allows the employer to distribute a percentage of its profits to its employees at a predetermined rate. The money may be paid directly to the employee or deposited into a retirement account."
    },
    {
       "key":726,
       "value":"progressive tax",
       "description":"A tax structure where the tax rate increases as the income level of the individual or entity increases."
    },
    {
       "key":727,
       "value":"project note",
       "description":"A municipal bond issued as interim financing in anticipation of the issuance of new housing authority bonds."
    },
    {
       "key":728,
       "value":"prospectus",
       "description":"See final prospectus."
    },
    {
       "key":729,
       "value":"proxy",
       "description":"A limited authority given by stockholders to another party to vote their shares in a corporate election. The stockholder may specify how the votes are cast or may give the party discretion."
    },
    {
       "key":730,
       "value":"proxy department",
       "description":"The department in a brokerage firm that is responsible for forwarding proxies and financial information to investors whose stock is held in street name."
    },
    {
       "key":731,
       "value":"prudent man rule",
       "description":"A rule that governs investments made by fiduciaries for the benefit of a third party. The rule states that the investments must be similar to those that a prudent person would make for himor herself."
    },
    {
       "key":732,
       "value":"public offering",
       "description":"The sale of securities by an issuer to public investors."
    },
    {
       "key":733,
       "value":"public offering price (POP)",
       "description":"The price paid by an investor to purchase open-end mutual fund shares. Also the price set for a security the first time it is sold to the investing public."
    },
    {
       "key":734,
       "value":"put",
       "description":"An option contract that allows the buyer to sell a security at a set price for a specific period of time. The seller of a put is obligated to purchase the security at a set price for a specific period of time, should the buyer exercise the option."
    },
    {
       "key":735,
       "value":"put buyer",
       "description":"A bearish investor who pays a premium for the right to sell a security at a set price for a certain period of time."
    },
    {
       "key":736,
       "value":"put spread",
       "description":"An option position created by the simultaneous purchase and sale of two put options on the same underlying security that differ in strike prices, expiration months, or both."
    },
    {
       "key":737,
       "value":"put writer",
       "description":"A bullish investor who sells a put option in order to receive the option premium. The writer is obligated to purchase the security if the buyer exercises the option."
    },
    {
       "key":738,
       "value":"qualified legal opinion",
       "description":"A legal opinion containing conditions or reservations relating to the issue. A legal opinion is issued by a bond counsel for a municipal issuer."
    },
    {
       "key":739,
       "value":"qualified retirement plan",
       "description":"A retirement plan that qualifies for favorable tax treatment by the IRS for contributions made into the plan."
    },
    {
       "key":740,
       "value":"quick assets",
       "description":"A measure of liquidity that subtracts the value of a corporation’s unsold inventory from its current assets."
    },
    {
       "key":741,
       "value":"quick ratio",
       "description":"See acid-test ratio."
    },
    {
       "key":742,
       "value":"quote",
       "description":"A bid and offer broadcast from the exchange or through the Nasdaq system that displays the prices at which a security may be purchased and sold and in what quantities."
    },
    {
       "key":743,
       "value":"range",
       "description":"The price difference between the high and low for a security."
    },
    {
       "key":744,
       "value":"rate covenant",
       "description":"A promise in the trust indenture of a municipal revenue bond to keep the user fees high enough to support the debt service."
    },
    {
       "key":745,
       "value":"rating",
       "description":"A judgment of an issuer’s ability to meet its credit obligations. The higher the credit quality of the issuer is, the higher the credit rating. The lower the credit quality is, the lower the credit rating, and the higher the risk associated with the securities."
    },
    {
       "key":746,
       "value":"rating service",
       "description":"Major financial organizations that evaluate the credit quality of issuers. Issuers have to request and pay for the service. Standard and Poor’s, Moody’s, and Fitch are the most widely followed rating services."
    },
    {
       "key":747,
       "value":"raw land program",
       "description":"A type of real estate limited partnership that invests in land for capital appreciation."
    },
    {
       "key":748,
       "value":"real estate investment trust (REIT)",
       "description":"An entity that is organized to invest in or manage real estate. REITs offer investors certain tax advantages and can avoid double taxation if the REIT passes through at least 90 % of net investment income."
    },
    {
       "key":749,
       "value":"real estate limited partnership",
       "description":"A type of direct participation program that invests in real estate projects to produce income or capital appreciation."
    },
    {
       "key":750,
       "value":"real estate mortgage investment conduit (REMIC)",
       "description":"An organization that pools investors’ capital to purchase portfolios of mortgages."
    },
    {
       "key":751,
       "value":"realized gain",
       "description":"A profit earned on the sale of a security at a price that exceeds its purchase price."
    },
    {
       "key":752,
       "value":"realized loss",
       "description":"A loss recognized by an investor by selling a security at a price that is less than its purchase price."
    },
    {
       "key":753,
       "value":"reallowance",
       "description":"A sales concession available to dealers who sell securities subject to an offering who are not syndicate or selling group members."
    },
    {
       "key":754,
       "value":"recapture",
       "description":"An event that causes a tax liability on a previously taken deduction, such as selling an asset above its depreciated cost base."
    },
    {
       "key":755,
       "value":"recession",
       "description":"A decline in GDP that lasts for at least 6 months but not longer than 18 months."
    },
    {
       "key":756,
       "value":"reclamation",
       "description":"The right of a seller to demand or claim any loss from the buying party due to the buyer’s failure to settle the transaction."
    },
    {
       "key":757,
       "value":"record date",
       "description":"A date set by a corporation’s board of directors that determines which shareholders will be entitled to receive a declared dividend. Shareholders must be owners of record on this date in order to collect the dividend."
    },
    {
       "key":758,
       "value":"recourse loan",
       "description":"A loan taken out by a limited partnership that allows the lender to seek payment from the limited partners in the case of the partnership’s failure to pay."
    },
    {
       "key":759,
       "value":"redeemable security",
       "description":"A security that can be redeemed by the issuer at the investor’s request. Open-end mutual funds are an example of redeemable securities."
    },
    {
       "key":760,
       "value":"redemption",
       "description":"The return of an investor’s capital by an issuer. Open-end mutual funds must redeem their securities within 7 days of an investor’s request."
    },
    {
       "key":761,
       "value":"red herring",
       "description":"See preliminary prospectus."
    },
    {
       "key":762,
       "value":"registered",
       "description":"A term that describes the level of owner information that is recorded by the security’s issuer."
    },
    {
       "key":763,
       "value":"registered as to principal only",
       "description":"A type of bond registration that requires the investor to clip coupons to receive the bond’s interest payments. The issuer will automatically send the investor the bond’s principal amount at maturity."
    },
    {
       "key":764,
       "value":"registered options principal (ROP)",
       "description":"An individual who has passed the Series 4 exam."
    },
    {
       "key":765,
       "value":"registered principal",
       "description":"A supervisor of a member firm who has passed the principal examination."
    },
    {
       "key":766,
       "value":"registered representative",
       "description":"An individual who has successfully completed a qualified examination to represent a broker dealer or issuer in securities transactions."
    },
    {
       "key":767,
       "value":"registrar",
       "description":"An independent organization that accounts for all outstanding stock and bonds of an issuer."
    },
    {
       "key":768,
       "value":"registration statement",
       "description":"The full disclosure statement that nonexempt issuers must file with the SEC prior to offering securities for sale to the public. The Securities Act of 1933 requires that a registration statement be filed."
    },
    {
       "key":769,
       "value":"regressive tax",
       "description":"A tax that is levied on all parties at the same rate, regardless of their income. An example of a regressive tax is a sales tax. A larger percentage of a low-income earner’s income is taken away by the tax."
    },
    {
       "key":770,
       "value":"regular-way settlement",
       "description":"The standard number of business days in which a securities transaction is completed and paid for."
    },
    {
       "key":771,
       "value":"regulated investment company",
       "description":"An investment company that qualifies as a conduit for net investment income under Internal Revenue Code subchapter M, so long as it distributes at least 90% of its net investment income to shareholders."
    },
    {
       "key":772,
       "value":"Regulation A",
       "description":"A Regulation A offering allows a company to raise up to 75 million dollars in a tier 2 offering and up to 20 million dollars in a tier 1 offering in any 12-month period."
    },
    {
       "key":773,
       "value":"Regulation D",
       "description":"A private placement or sale of securities that allows for an exemption from registration under the Securities Act of 1933. A private placement may be sold to an unlimited number of accredited investors but may only be sold to 35 nonaccredited investors in any 12-month period."
    },
    {
       "key":774,
       "value":"Regulation G",
       "description":"Regulates the extension of credit for securities purchases by other commercial lenders."
    },
    {
       "key":775,
       "value":"Regulation T",
       "description":"Regulates the extension of credit by broker dealers for securities purchases."
    },
    {
       "key":776,
       "value":"Regulation U",
       "description":"Regulates the extension of credit by banks for securities purchases."
    },
    {
       "key":777,
       "value":"Regulation X",
       "description":"Regulates the extension of credit by overseas lenders for securities purchases."
    },
    {
       "key":778,
       "value":"Rehypothecation",
       "description":"The act of a broker dealer repledging a customer’s securities as collateral at a bank to obtain a loan for the customer."
    },
    {
       "key":779,
       "value":"REIT",
       "description":"See real estate investment trust (REIT)."
    },
    {
       "key":780,
       "value":"rejection",
       "description":"The act of a buyer of a security refusing delivery."
    },
    {
       "key":781,
       "value":"reorganization department",
       "description":"The department in a brokerage firm that handles changes in securities that result from a merger or acquisition or calls."
    },
    {
       "key":782,
       "value":"repurchase agreement (REPO)",
       "description":"A fully collateralized loan that results in a sale of securities to the lender, with the borrower agreeing to repurchase them at a higher price in the future. The higher price represents the lender’s interest."
    },
    {
       "key":783,
       "value":"reserve maintenance fund",
       "description":"An account set up to provide additional funds to maintain a revenue-producing facility financed by a revenue bond."
    },
    {
       "key":784,
       "value":"reserve requirement",
       "description":"A deposit required to be placed on account with the Federal Reserve Board by banks. The requirement is a percentage of the bank’s customers’ deposits."
    },
    {
       "key":785,
       "value":"resistance",
       "description":"A price level to which a security appreciates and attracts sellers. The new sellers keep the security’s price from rising any higher."
    },
    {
       "key":786,
       "value":"restricted account",
       "description":"<ol style='margin-left: 25px;  list-style-type: decimal;'><li>A long margin account that has less than 50% equity but more than 25% or a short margin account that has equity of less than 50% but more than 30%. </li><li>(2) A customer account that has been subject to a sellout.</li></ol>"
    },
    {
       "key":787,
       "value":"restricted stock",
       "description":"A nonexempt unregistered security that has been obtained by means other than a public offering."
    },
    {
       "key":788,
       "value":"retail communication",
       "description":"Any communication that may be seen in whole or in part by more than 25  investors in a 30 day period. . Retail communication must be approved by a principal prior to first use and maintained by the firm for 3 years."
    },
    {
       "key":789,
       "value":"retained earnings",
       "description":"The amount of a corporation’s net income that has not been paid out to shareholders as dividends."
    },
    {
       "key":790,
       "value":"retention",
       "description":"The amount of a new issue that an underwriter allocates to its own clients."
    },
    {
       "key":791,
       "value":"retention requirement",
       "description":"The amount of equity that must be left in a restricted margin account when withdrawing securities."
    },
    {
       "key":792,
       "value":"return on equity",
       "description":"A measure of performance found by dividing after-tax income by common stockholders’ equity."
    },
    {
       "key":793,
       "value":"return on investment (ROI)",
       "description":"The profit or loss realized by an investor from holding a security expressed as a percentage of the invested capital."
    },
    {
       "key":794,
       "value":"revenue anticipation note",
       "description":"A short-term municipal issue that is sold to manage an issuer’s cash flow in anticipation of other revenue in the future."
    },
    {
       "key":795,
       "value":"reverse repurchase agreement",
       "description":"A fully collateralized loan that results in the purchase of securities with the intention of reselling them to the borrower at a higher price. The higher price represents the buyer’s/lender’s interest."
    },
    {
       "key":796,
       "value":"reverse split",
       "description":"A stock split that results in fewer shares outstanding, with each share being worth proportionally more."
    },
    {
       "key":797,
       "value":"reversionary working interest",
       "description":"A revenue-sharing arrangement where the general partner shares none of the cost and receives none of the revenue until the limited partners have received their payments back, plus any predetermined amount of return."
    },
    {
       "key":798,
       "value":"right",
       "description":"A short-term security issued in conjunction with a shareholder’s preemptive right. The maximum length of a right is 45 days, and it is issued with a subscription price, which allows the holder to purchase the underlying security at a discount from its market price."
    },
    {
       "key":799,
       "value":"rights agent",
       "description":"An independent entity responsible for maintaining the records for rights holders."
    },
    {
       "key":800,
       "value":"rights of accumulation",
       "description":"A right offered to mutual fund investors that allows them to calculate all past contributions and growth to reach a breakpoint to receive a sales charge discount on future purchases."
    },
    {
       "key":801,
       "value":"rights offering",
       "description":"The offering of new shares by a corporation that is preceded by the offering of the new shares to existing shareholders."
    },
    {
       "key":802,
       "value":"riskless simultaneous transaction",
       "description":"The purchase of a security on a principal basis by a brokerage firm for the sole purpose of filling a customer’s order that the firm has already received. The markup on riskless principal transactions has to be based on the firm’s actual cost for the security."
    },
    {
       "key":803,
       "value":"rollover",
       "description":"The distribution of assets from a qualified account to an investor for the purpose of depositing the assets in another qualified account within 60 days. An investor may only roll over an IRA once every 12 months."
    },
    {
       "key":804,
       "value":"round lot",
       "description":"A standard trading unit for securities. For common and preferred stock, a round lot is 100 shares."
    },
    {
       "key":805,
       "value":"Rule 144",
       "description":"SEC rule that regulates the sale of restricted and control securities requiring the seller to file Form 144 at the time the order is entered to sell. Rule 144 also regulates the number of securities that may be sold."
    },
    {
       "key":806,
       "value":"Rule 145",
       "description":"SEC rule that requires a corporation to provide stockholders with full disclosure relating to reorganizations and to solicit proxies."
    },
    {
       "key":807,
       "value":"Rule 147",
       "description":"An intrastate offering that provides an exemption from SEC registration."
    },
    {
       "key":808,
       "value":"Rule 405",
       "description":"The NYSE rule that requires that all customer recommendations must be suitable and that the representative must “know” the customer."
    },
    {
       "key":809,
       "value":"sale",
       "description":"See sell."
    },
    {
       "key":810,
       "value":"sales charge",
       "description":"See commission."
    },
    {
       "key":811,
       "value":"sales load",
       "description":"The amount of commission charged to investors in open-end mutual funds. The amount of the sales load is added to the net asset value of the fund to determine the public offering price of the fund."
    },
    {
       "key":812,
       "value":"satellite office",
       "description":"An office not identified to the public as an office of the member, such as an agent’s home office."
    },
    {
       "key":813,
       "value":"savings bond",
       "description":"A nonnegotiable U. S. government bond that must be purchased from the government and redeemed to the government. These bonds are generally known as Series EE and HH bonds."
    },
    {
       "key":814,
       "value":"scale",
       "description":"A list of maturities and yields for a new serial bond issue."
    },
    {
       "key":815,
       "value":"Schedule 13D",
       "description":"A form that must be filed with the SEC by any individual or group of individuals acquiring 5% or more of a corporation’s nonexempt equity securities. Form 13D must be filed within 10 days of the acquisition."
    },
    {
       "key":816,
       "value":"scheduled premium policy",
       "description":"A variable life insurance policy with fixed premium payments."
    },
    {
       "key":817,
       "value":"SEC",
       "description":"See Securities and Exchange Commission (SEC)."
    },
    {
       "key":818,
       "value":"secondary distribution",
       "description":"A distribution of a large number of securities by a large shareholder or group of large shareholders. The distribution may or may not be done under a prospectus."
    },
    {
       "key":819,
       "value":"secondary offering",
       "description":"An underwriting of a large block of stock being sold by large shareholders. The proceeds of the issue are received by the selling shareholders, not the corporation."
    },
    {
       "key":820,
       "value":"secondary market",
       "description":"A marketplace where securities are exchanged between investors. All transactions that take place on an exchange or on the Nasdaq are secondary market transactions."
    },
    {
       "key":821,
       "value":"sector fund",
       "description":"A mutual fund that invests in companies within a specific business area in an effort to maximize gains. Sector funds have larger risk-reward ratios because of the concentration of investments."
    },
    {
       "key":822,
       "value":"Securities Act of 1933",
       "description":"The first major piece of securities industry legislation. It regulates the primary market and requires that nonexempt issuers file a registration statement with the SEC. The act also requires that investors in new issues be given a prospectus."
    },
    {
       "key":823,
       "value":"Securities Act Amendments of 1975",
       "description":"Created the Municipal Securities Rulemaking Board (MSRB)."
    },
    {
       "key":824,
       "value":"Securities Exchange Act of 1934",
       "description":"Regulates the secondary market and all broker dealers and industry participants. It created the Securities and Exchange Commission, the industry’s ultimate authority. The act gave the authority to the Federal Reserve Board to regulate the extension of credit for securities purchases through Regulation T."
    },
    {
       "key":825,
       "value":"Securities and Exchange Commission",
       "description":"The ultimate securities industry authority. The SEC is a direct government body, not a self-regulatory organization. The commissioners are appointed by the U.S. President and must be approved by Congress."
    },
    {
       "key":826,
       "value":"Securities Investor Protection Corporation (SIPC)",
       "description":"The industry’s nonprofit insurance company that provides protection for investors in case of broker dealer failure. All member firms must pay dues to SIPC based upon their revenue. SIPC provides coverage for each separate customer for up to $500,000, of which a maximum of $250,000 may be cash. The Securities Investor Protection Act of 1970 created SIPC."
    },
    {
       "key":827,
       "value":"security",
       "description":"Any investment that can be exchanged for value between two parties that contains risk. Securities include stocks, bonds, mutual funds, notes, rights, warrants, and options, among others."
    },
    {
       "key":828,
       "value":"segregation",
       "description":"The physical separation of customer and firm assets."
    },
    {
       "key":829,
       "value":"self-regulatory organization (SRO)",
       "description":"An industry authority that regulates its own members. FINRA, the NYSE, and the CBOE are all self-regulatory organizations that regulate their own members."
    },
    {
       "key":830,
       "value":"sell",
       "description":"The act of conveying the ownership of a security for value to another party. A sale includes any security that is attached to another security, as well as any security which the security may be converted or exchanged into."
    },
    {
       "key":831,
       "value":"seller’s option",
       "description":"A type of settlement option that allows the seller to determine when delivery of the securities and final settlement of the trade will occur."
    },
    {
       "key":832,
       "value":"selling away",
       "description":"Any recommendation to a customer that involves an investment product that is not offered through the employing firm without the firm’s knowledge and consent. This is a violation of industry regulations and may result in action being taken against the representative."
    },
    {
       "key":833,
       "value":"selling concession",
       "description":"See concession."
    },
    {
       "key":834,
       "value":"selling dividends",
       "description":"The act of using a pending dividend to create urgency for the customer to purchase a security. This is a violation and could result in action being taken against the representative."
    },
    {
       "key":835,
       "value":"selling group",
       "description":"A group of broker dealers who may sell a new issue of securities but who are not members of the syndicate and who have no liability to the issuer."
    },
    {
       "key":836,
       "value":"sell out",
       "description":"A transaction executed by a broker dealer when a customer fails to pay for the securities."
    },
    {
       "key":837,
       "value":"sell-stop order",
       "description":"An order placed beneath the current market for a security to protect a profit, to guard against a loss, or to establish a short position."
    },
    {
       "key":838,
       "value":"separate account",
       "description":"The account established by an insurance company to invest the pooled funds of variable contract holders in the securities markets. The separate account must register as either an open-end investment company or as a unit investment trust."
    },
    {
       "key":839,
       "value":"separate trading of registered interest and principal",
       "description":"A zero-coupon bond issued by the U.S. government. The principal payment due in the future is sold to investors at a discount and appreciates to par at maturity."
    },
    {
       "key":840,
       "value":"securities (STRIPS)",
       "description":"The interest payment component is sold to other investors who want some current income."
    },
    {
       "key":841,
       "value":"serial bonds",
       "description":"A bond issue that has an increasing amount of principal maturing in successive years."
    },
    {
       "key":842,
       "value":"settlement",
       "description":"The completion of a securities transaction. A transaction settles and is completed when the security is delivered to the buyer and the cash is delivered to the seller."
    },
    {
       "key":843,
       "value":"settlement date",
       "description":"The date when a securities ownership changes. Settlement dates are set by FINRA’s Uniform Practice Code."
    },
    {
       "key":844,
       "value":"75-5-10 diversification",
       "description":"The diversification test that must be met by mutual funds under the Investment Company Act of 1940 in order to market themselves as a diversified mutual fund: 75% of the fund’s assets must be invested in other issuer’s securities, no more than 5% of the fund’s assets may be invested in any one company, and the fund may own no more than 10% of an issuer’s outstanding securities."
    },
    {
       "key":845,
       "value":"shareholder’s equity",
       "description":"See net worth."
    },
    {
       "key":846,
       "value":"share identification",
       "description":"The process of identifying which shares are being sold at the time the sale order is entered in order to minimize an investor’s tax liability."
    },
    {
       "key":847,
       "value":"shelf offering",
       "description":"A type of securities registration that allows the issuer to sell the securities over a 2-year period. Well-known, seasoned issuers may sell securities over a 3-  year period."
    },
    {
       "key":848,
       "value":"short",
       "description":"A position established by a bearish investor that is created by borrowing the security and selling in the hopes that the price of the security will fall. The investor hopes to be able to repurchase the security at a lower price, thus replacing it cheaply. If the security’s price rises, the investor will suffer a loss."
    },
    {
       "key":849,
       "value":"short against the box",
       "description":"A short position established against an equal long position in the security to roll tax liabilities forward. Most of the benefits of establishing a short against the box position have been eliminated."
    },
    {
       "key":850,
       "value":"short straddle",
       "description":"The simultaneous sale of a call and a put on the same underlying security with the same strike price and expiration. A short straddle would be established by an investor who believes that the security price will move sideways."
    },
    {
       "key":851,
       "value":"simplified arbitration",
       "description":"A method of resolving disputes of $50,000 or less. There is no hearing; one arbitrator reads the submissions and renders a final decision."
    },
    {
       "key":852,
       "value":"Simplified Employee Pension (SEP)",
       "description":"A qualified retirement plan created for small employers with 25 or fewer employees that allows the employees’ money to grow tax-deferred until retirement."
    },
    {
       "key":853,
       "value":"single account",
       "description":"An account operated for one individual. The individual has control of the account, and the assets go to the individual’s estate in the case of his or her death."
    },
    {
       "key":854,
       "value":"sinking fund",
       "description":"An account established by an issuer of debt to place money for the exclusive purpose of paying bond principal."
    },
    {
       "key":855,
       "value":"special assessment bond",
       "description":"A municipal bond backed by assessments from the property that benefits from the improvements."
    },
    {
       "key":856,
       "value":"specialist",
       "description":"Member of an exchange responsible for maintaining a fair and orderly market in the securities that he or she specializes in and for executing orders left with him or her."
    },
    {
       "key":857,
       "value":"specialist book",
       "description":"A book of limit orders left with the specialist for execution."
    },
    {
       "key":858,
       "value":"special situation fund",
       "description":"A fund that seeks to take advantage of unusual corporate developments, such as mergers and restructuring."
    },
    {
       "key":859,
       "value":"special tax bond",
       "description":"A type of municipal revenue bond that is supported only by revenue from certain taxes."
    },
    {
       "key":860,
       "value":"speculation",
       "description":"An investment objective where the investor is willing to accept a high degree of risk in exchange for the opportunity to realize a high return."
    },
    {
       "key":861,
       "value":"split offering",
       "description":"An offering where a portion of the proceeds from the underwriting goes to the issuer and a portion goes to the selling shareholders."
    },
    {
       "key":862,
       "value":"spousal account",
       "description":"An IRA opened for a nonworking spouse that allows a full contribution to be made for the nonworking spouse."
    },
    {
       "key":863,
       "value":"spread",
       "description":"(1) The difference between the bid and ask for a security. (2) The simultaneous purchase and sale of two calls or two puts on the same underlying security."
    },
    {
       "key":864,
       "value":"spread load plan",
       "description":"A contractual plan that seeks to spread the sales charge over a longer period of time, as detailed in the Spread Load Plan Act of 1970. The maximum sales charge over the life of the plan is 9%, while the maximum sales charge in any one year is 20%."
    },
    {
       "key":865,
       "value":"stabilizing",
       "description":"The only form of price manipulation allowed by the SEC. The managing underwriter enters a bid at or below the offering price to ensure even distribution of shares."
    },
    {
       "key":866,
       "value":"standby underwriting",
       "description":"An underwriting used in connection with a preemptive rights offering. The standby underwriter must purchase any shares not subscribed to by existing shareholders."
    },
    {
       "key":867,
       "value":"statutory disqualification",
       "description":"A set of rules that prohibit an individual who has been barred or suspended or convicted of a securities-related crime from becoming registered."
    },
    {
       "key":868,
       "value":"statutory voting",
       "description":"A method of voting that requires investors to cast their votes evenly for the directors they wish to elect."
    },
    {
       "key":869,
       "value":"stock ahead",
       "description":"A condition that causes an investor’s order not to be executed, even though the stock is trading at a price that would satisfy the customer’s limit order, because other limit orders have been entered prior to the customer’s order."
    },
    {
       "key":870,
       "value":"stock certificate",
       "description":"Evidence of equity ownership."
    },
    {
       "key":871,
       "value":"stock or bond power",
       "description":"A form that, when signed by the owner and attached to a security, makes the security negotiable."
    },
    {
       "key":872,
       "value":"stock split",
       "description":"A change in the number of outstanding shares, the par value, and the number of authorized shares that has been approved through a vote of the shareholders. Forward-stock splits increase the number of shares outstanding and reduce the stock price in order to make the security more attractive to individual investors."
    },
    {
       "key":873,
       "value":"stop limit order",
       "description":"An order that becomes a limit order to buy or sell the stock when the stock trades at or through the stop price."
    },
    {
       "key":874,
       "value":"stop order",
       "description":"An order that becomes a market order to buy or sell the stock when the stock trades at or through the stop price."
    },
    {
       "key":875,
       "value":"stopping stock",
       "description":"A courtesy offered by a specialist to public customers, whereby the specialist guarantees a price but tries to obtain a better price for the customer."
    },
    {
       "key":876,
       "value":"straddle",
       "description":"The simultaneous purchase or sale of a call and a put on the same security with the same strike price and expiration."
    },
    {
       "key":877,
       "value":"straight line depreciation",
       "description":"An accounting method that allows an owner to take equal tax deductions over the useful life of the asset."
    },
    {
       "key":878,
       "value":"strangle",
       "description":"The purchase or sale of a call and a put on either side of the current market price. The options have the same expiration months but different strike prices."
    },
    {
       "key":879,
       "value":"stripped bond",
       "description":"A bond that has had its coupons removed by a broker dealer and that is selling at a deep discount to its principal payment in the future."
    },
    {
       "key":880,
       "value":"stripper well",
       "description":"An oil well that is in operation just to recover a very limited amount of reserves."
    },
    {
       "key":881,
       "value":"subchapter S corporation",
       "description":"A business organization that allows the tax consequences of the organization to flow through to the owners."
    },
    {
       "key":882,
       "value":"subscription agreement",
       "description":"An application signed by the purchaser of an interest in a direct participation plan. An investor in a limited partnership does not become an investor until the general partner signs the subscription agreement."
    },
    {
       "key":883,
       "value":"subscription right",
       "description":"See right."
    },
    {
       "key":884,
       "value":"suitability",
       "description":"A determination that the characteristics of a security are in line with an investor’s objectives, financial profile, and attitudes."
    },
    {
       "key":885,
       "value":"Super Display Book System (SDBK)",
       "description":"The electronic order-routing system used by the NYSE to route orders directly to the trading post."
    },
    {
       "key":886,
       "value":"supervise",
       "description":"The actions of a principal that ensure that the actions of a firm and its representatives are in compliance with industry regulations."
    },
    {
       "key":887,
       "value":"support",
       "description":"The price to which a security will fall and attract new buyers. As the new buyers enter the market, it keeps the price from falling any lower."
    },
    {
       "key":888,
       "value":"surplus fund",
       "description":"An account set up for funds generated by a project financed by a municipal revenue bond to pay a variety of expenses."
    },
    {
       "key":889,
       "value":"syndicate",
       "description":"A group of underwriters responsible for underwriting a new issue."
    },
    {
       "key":890,
       "value":"systematic risk",
       "description":"A risk inherent in any investment in the market. An investor may lose money simply because the market is going down."
    },
    {
       "key":891,
       "value":"takedown",
       "description":"The price at which a syndicate purchases a new issue of securities from the issuer."
    },
    {
       "key":892,
       "value":"tax and revenue anticipation note",
       "description":"A short-term note sold by a municipal issuer as interim financing in anticipation of tax and other revenue."
    },
    {
       "key":893,
       "value":"tax anticipation note (TAN)",
       "description":"A short-term note sold by a municipal issuer as interim financing in anticipation of tax revenue."
    },
    {
       "key":894,
       "value":"tax-deferred annuity",
       "description":"A nonqualified retirement account that allows an investor’s money to grow tax deferred. A tax-deferred annuity is a contract between an insurance company and an investor."
    },
    {
       "key":895,
       "value":"tax equivalent yield",
       "description":"The interest rate that must be offered by a taxable bond of similar quality in order to be equal to the rate that is offered by a municipal bond."
    },
    {
       "key":896,
       "value":"tax-exempt bond fund",
       "description":"A bond fund that seeks to produce investment income that is free from federal tax by investing in a portfolio of municipal bonds."
    },
    {
       "key":897,
       "value":"tax liability",
       "description":"The amount of money that is owed by an investor after realizing a gain on the sale of an investment or after receiving investment income."
    },
    {
       "key":898,
       "value":"tax preference item",
       "description":"An item that receives preferential tax treatment and must be added back into income when calculating an investor’s alternative minimum tax."
    },
    {
       "key":899,
       "value":"tax-sheltered annuity (TSA)",
       "description":"A qualified retirement plan offered to employees of governments, school systems, or nonprofit organizations. Contributions to TSAs are made with pre-tax dollars."
    },
    {
       "key":900,
       "value":"technical analysis",
       "description":"A method of security analysis that uses past price performance to predict the future performance of a security."
    },
    {
       "key":901,
       "value":"Telephone Consumer Protection Act of 1991",
       "description":"Legislation that regulates how potential customers are contacted by phone at home."
    },
    {
       "key":902,
       "value":"tenants in common",
       "description":"See joint tenants in common."
    },
    {
       "key":903,
       "value":"tender offer",
       "description":"An offer to buy all or part of a company’s outstanding securities for cash or cash and securities."
    },
    {
       "key":904,
       "value":"term bond",
       "description":"A bond issue that has its entire principal due on one date."
    },
    {
       "key":905,
       "value":"term maturity",
       "description":"A type of bond maturity that has all principal due on one date."
    },
    {
       "key":906,
       "value":"testimonial",
       "description":"The use of a recognized expert or leader to endorse the services of a firm."
    },
    {
       "key":907,
       "value":"third market",
       "description":"A transaction in an exchange-listed security executed over the Nasdaq workstation."
    },
    {
       "key":908,
       "value":"third-party account",
       "description":"An account that is managed for the benefit of a customer by another party, such as an investment adviser, a trustee, or an attorney."
    },
    {
       "key":909,
       "value":"30-day visible supply",
       "description":"The total par value of all new issue municipal bonds coming to market in the next 30 days."
    },
    {
       "key":910,
       "value":"time deposit",
       "description":"An account that is established by a bank customer where the customer agrees to leave the funds on deposit for an agreed upon amount of time."
    },
    {
       "key":911,
       "value":"time value",
       "description":"The value of an option that exceeds its intrinsic value or its in-the-money amount."
    },
    {
       "key":912,
       "value":"tombstone ad",
       "description":"An announcement published in financial papers advertising the offering of securities by a group of underwriters. Only basic information may be contained in the tombstone ad, and all offers must be made through the prospectus only."
    },
    {
       "key":913,
       "value":"top heavy rule",
       "description":"The rule that states the maximum salary for which a Keogh contribution may be based. This is in effect to limit the disparity between highand low-salary employees."
    },
    {
       "key":914,
       "value":"trade confirmation",
       "description":"The printed notification of a securities transaction. A confirmation must be sent to a customer on or before the completion of a transaction. The completion of a transaction is considered to be the settlement date."
    },
    {
       "key":915,
       "value":"trade date",
       "description":"The day when an investor’s order is executed."
    },
    {
       "key":916,
       "value":"tranche",
       "description":"A class of collateralized mortgage obligation (CMO) that has a predicted maturity and interest rate."
    },
    {
       "key":917,
       "value":"transfer agent",
       "description":"An independent entity that handles name changes, records the names of security holders of record, and ensures that all certificates are properly endorsed."
    },
    {
       "key":918,
       "value":"transfer and hold in safekeeping",
       "description":"A request by customers for the brokerage firm to transfer their securities into the firm’s name and to hold them in safekeeping at the firm. A brokerage may charge a fee for holding a customer’s securities that have been registered in its name."
    },
    {
       "key":919,
       "value":"transfer and ship",
       "description":"A request by customers for the brokerage firm to transfer their securities into their name and to ship them to their address of record."
    },
    {
       "key":920,
       "value":"Treasury bill",
       "description":"A U.S. government security that is issued at a discount and matures at par in 4, 13, 26, and 52 weeks."
    },
    {
       "key":921,
       "value":"Treasury bond",
       "description":"A long-term U.S. government security that pays semiannual interest and matures in 10 to 30 years."
    },
    {
       "key":922,
       "value":"Treasury note",
       "description":"An intermediateterm U.S. government security that pays semiannual interest and matures in 1 to 10 years."
    },
    {
       "key":923,
       "value":"Treasury receipt",
       "description":"A zero-coupon bond created by a brokerage firm that is backed by U.S. government securities. It is issued at a discount and matures at par."
    },
    {
       "key":924,
       "value":"treasury stock",
       "description":"Stock that has been issued by a corporation and that has subsequently been repurchased by the corporation. Treasury stock does not vote or receive dividends. It is not used in the calculation of earnings per share."
    },
    {
       "key":925,
       "value":"trendline",
       "description":"A line used to predict the future price movement for a security. Drawing a line under the successive lows or successive highs creates a trendline."
    },
    {
       "key":926,
       "value":"trough",
       "description":"The bottoming out of the business cycle just prior to an new upward movement in activity."
    },
    {
       "key":927,
       "value":"true interest cost (TIC)",
       "description":"A calculation for the cost of a municipal issuer’s interest expense that includes the time value of money."
    },
    {
       "key":928,
       "value":"Trust Indenture Act of 1940",
       "description":"Regulates the issuance of corporate debt in excess of $5 million and with a term exceeding 1 year. It requires an indenture between the issuer and the trustee."
    },
    {
       "key":929,
       "value":"trustee",
       "description":"A person who legally acts for the benefit of another party."
    },
    {
       "key":930,
       "value":"12B-1 fee",
       "description":"An asset-based distribution fee that is assessed annually and paid out quarterly to cover advertising and distribution costs. All 12B-1 fees must be reasonable."
    },
    {
       "key":931,
       "value":"two-dollar broker",
       "description":"An independent exchange member who executes orders for commission house brokers and other customers for a fee."
    },
    {
       "key":932,
       "value":"type",
       "description":"A classification method for an option as either a call or a put."
    },
    {
       "key":933,
       "value":"uncovered",
       "description":"See naked."
    },
    {
       "key":934,
       "value":"underlying security",
       "description":"A security for which an investor has an option to buy or sell."
    },
    {
       "key":935,
       "value":"underwriting",
       "description":"The process of marketing a new issue of securities to the investing public. A broker dealer forwards the proceeds of the sale to the issuer minus its fee for selling the securities."
    },
    {
       "key":936,
       "value":"unearned income",
       "description":"Any income received by an individual from an investment, such as dividends and interest income."
    },
    {
       "key":937,
       "value":"uniform delivery ticket",
       "description":"A document that must be attached to every security delivered by the seller, making the security “good delivery.”"
    },
    {
       "key":938,
       "value":"Uniform Gifts to Minors Act (UGMA)",
       "description":"Sets forth guidelines for the gifting of cash and securities to minors and for the operation of accounts managed for the benefit of minors. Once a gift is given to a minor, it is irrevocable."
    },
    {
       "key":939,
       "value":"Uniform Practice Code",
       "description":"The FINRA bylaw that sets guidelines for how industry members transact business with other members. The Uniform Practice Code establishes such things as settlement dates, rules of good delivery, and ex-dividend dates."
    },
    {
       "key":940,
       "value":"Uniform Securities Act (USA)",
       "description":"The framework for state-based securities legislation. The act is a model that can be adapted to each state’s particular needs."
    },
    {
       "key":941,
       "value":"Uniform Transfer to Minors Act (UTMA)",
       "description":"Legislation that has been adopted in certain states, in lieu of the Uniform Gifts to Minors Act. UTMA allows the custodian to determine the age at which the assets become the property of the minor. The maximum age for transfer of ownership is 25."
    },
    {
       "key":942,
       "value":"unit investment trust (UIT)",
       "description":"A type of investment company organized as a trust to invest in a portfolio of securities. The UIT sells redeemable securities to investors in the form of shares or units of beneficial interest."
    },
    {
       "key":943,
       "value":"unit of beneficial interest",
       "description":"The redeemable share issued to investors in a unit investment trust."
    },
    {
       "key":944,
       "value":"unit refund annuity",
       "description":"An annuity payout option that will make payments to the annuitant for life. If the annuitant dies prior to receiving an amount that is equal to his or her account value, the balance of the account will be paid to the annuitant’s beneficiaries."
    },
    {
       "key":945,
       "value":"unqualified legal opinion",
       "description":"A legal opinion issued by a bond attorney for the issue where there are no reservations relating to the issue."
    },
    {
       "key":946,
       "value":"unrealized",
       "description":"A paper profit or loss on a security that is still owned."
    },
    {
       "key":947,
       "value":"variable annuity",
       "description":"A contract issued by an insurance company that is both a security and an insurance product. The annuitant’s contributions are invested through the separate account into a portfolio of securities. The annuitant’s payments depend largely on the investment results of the separate account."
    },
    {
       "key":948,
       "value":"variable death benefit",
       "description":"The amount of a death benefit paid to a beneficiary based on the investment results of the insurance company’s separate account. This amount is over the contract’s minimum guaranteed death benefit."
    },
    {
       "key":949,
       "value":"variable life insurance",
       "description":"A life insurance policy that provides for a minimum guaranteed death benefit, as well as an additional death benefit, based on the investment results of the separate account."
    },
    {
       "key":950,
       "value":"variable rate municipal security",
       "description":"Interim municipal financing issued with a variable rate."
    },
    {
       "key":951,
       "value":"vertical spread",
       "description":"The simultaneous purchase and sale of two calls or two puts on the same underlying security that differ only in strike price."
    },
    {
       "key":952,
       "value":"vesting",
       "description":"The process by which an employer’s contributions to an employee’s retirement account become the property of the employee."
    },
    {
       "key":953,
       "value":"visible supply",
       "description":"See 30-day visible supply."
    },
    {
       "key":954,
       "value":"voluntary accumulation plan",
       "description":"A method, such as dollar-cost averaging, by which an investor regularly makes contributions to acquire mutual fund shares."
    },
    {
       "key":955,
       "value":"voting right",
       "description":"The right of a corporation’s stockholders to cast their votes for the election of the corporation’s board of directors as well as for certain major corporate issues."
    },
    {
       "key":956,
       "value":"warrant",
       "description":"A long-term security that gives the holder the right to purchase the common shares of a corporation for up to 10 years. The warrant’s subscription price is always higher than the price of the underlying common shares when the warrant is initially issued."
    },
    {
       "key":957,
       "value":"wash sale",
       "description":"The sale of a security at a loss and the subsequent repurchase of that security or of a security that is substantially the same within 30 days of the sale. The repurchase disallows the claim of the loss for tax purposes."
    },
    {
       "key":958,
       "value":"western account",
       "description":"A type of municipal security syndicate account where only the member with unsold bonds is responsible for the unsold bonds."
    },
    {
       "key":959,
       "value":"when-issued security",
       "description":"A security that has been sold prior to the certificates being available for delivery."
    },
    {
       "key":960,
       "value":"wildcatting",
       "description":"An exploratory oiland gas-drilling program."
    },
    {
       "key":961,
       "value":"wire room",
       "description":"See order department."
    },
    {
       "key":962,
       "value":"withdrawal plan",
       "description":"The systematic removal of funds from a mutual fund account over time. Withdrawal plans vary in type and availability among fund companies."
    },
    {
       "key":963,
       "value":"workable indication",
       "description":"An indication of the prices and yields that a municipal securities dealer may be willing to buy or sell bonds."
    },
    {
       "key":964,
       "value":"working capital",
       "description":"A measure of a corporation’s liquidity that is found by subtracting current liabilities from current assets."
    },
    {
       "key":965,
       "value":"working interest",
       "description":"An interest that requires the holder to bear the proportional expenses and allows the holder to share in the revenue produced by an oil or gas project in relation to the interest."
    },
    {
       "key":966,
       "value":"workout quote",
       "description":"A nonfirm quote that requires handling and settlement conditions to be worked out between the parties prior to the trade."
    },
    {
       "key":967,
       "value":"writer",
       "description":"An investor who sells an option to receive the premium income."
    },
    {
       "key":968,
       "value":"writing the scale",
       "description":"The procedure of assigning prospective yields to a new issuer of serial municipal bonds."
    },
    {
       "key":969,
       "value":"yield",
       "description":"The annual amount of income generated by a security relative to its price; expressed as a percentage."
    },
    {
       "key":970,
       "value":"yield-based option",
       "description":"An interest rate option that allows the holder to receive the in-the-money amount in cash upon exercise or expiration."
    },
    {
       "key":971,
       "value":"yield curve",
       "description":"The rate at which interest rates vary among investments of similar quality with different maturities. Longer-term securities generally offer higher yields."
    },
    {
       "key":972,
       "value":"yield to call",
       "description":"An investor’s overall return for owning a bond should it be called in prior to maturity by the issuer."
    },
    {
       "key":973,
       "value":"yield to maturity",
       "description":"An investor’s overall return for owning a bond if the bond is held until maturity."
    },
    {
       "key":974,
       "value":"zero-coupon bond",
       "description":"A bond that is issued at a discount from its par value and makes no regular interest payments. An investor’s interest is reflected by the security’s appreciation toward par at maturity. The appreciation is taxable each year even though it is not actually received by the investor (phantom income)."
    },
    {
       "key":975,
       "value":"zero-minus tick",
       "description":"A trade in an exchange-listed security that occurs at the same price as the previous transaction, but at a price that is lower than the last transaction that was different."
    },
    {
       "key":976,
       "value":"zero-plus tick",
       "description":"A trade in an exchange-listed security that occurs at the same price as the previous transaction, but at a price that is higher than the last transaction that was different."
    }
  ]